import { Modal, Nav, OverlayTrigger, Tab, Tooltip } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import "./calendarModal.scss";
import Button from "../command/Button/Button";
import { addDays } from "date-fns";

// import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import { useNavigate } from "react-router-dom";
import {
  isAfter,
  isBefore,
  setHours,
  setMinutes,
} from "date-fns";

import { format } from "date-fns-tz";

import { productDetailsClient } from "../../data/product-details";
import { Clock, Info } from "react-feather";
import { getAuthCredentials, setQuoteCookies } from "../../utils/auth-utils";
import Select, { components, GroupBase, StylesConfig } from 'react-select';
import { Calendar } from "react-calendar";
import { CalendarMontlyIcon, CalendarSimpleIcon } from "../../assets/svgIcon/customIcon";
import moment from "moment-timezone";
import CustomModal from "../command/model/customModel";
import {
  calculateDurationFlag,
  countDays,
  getInactiveDays,
  getReturnDate,
  isSameDate,
} from "../../utils/utils";
import { useTranslation } from "react-i18next";
import customStyles from "./dateSelectOption";
import { toast } from "react-toastify";
import { dayOptionLabel, dayOptionValue, rentalType } from "../../utils/constants";
import { useAuth } from "../../contexts/authContext";
interface CalendarModalProps {
  show: boolean;
  getQuoteData?: any;
  details?: any;
  productDetailsByUUID?: any;
  onHide: () => void;
  onDateSelect?: any;
  productuuid?: any;
  productpricing?: any;
  commonProductPricing?: any;
  storeDetails?: any;
  productVariantUuid?: string | null;
  isAvailableForPurchaseAfterRent?: boolean;
  productRetailValue?: number;
  variantOptions?: {
    option1?: string;
    option2?: string;
    option3?: string;
  };
  openAddOnModal?: () => void;
  setQuoteProductData?: (data: any) => void;
  selectedQuantity?: number;
}
interface OptionType {
  value: string;
  label: string;
  isDisabled?: boolean;
  categoryType?: 'hourly' | 'daily' | 'weekly' | 'monthly';
  key?: 'oneHour' | 'twoHours' | 'threeHours' | 'threeAndHalfHours' | 'fourHours' | 'sevenAndHalfHours' | 'fullDay' | 'oneDay' | 'twoDays' | 'threeDays' | 'fourDays' | 'fiveDays' |
  'sixDays' | 'sevenDays' | 'eightDays' | 'nineDays' | 'tenDays' | 'fourteenDays' | 'twentyoneDays' | 'twentyeightDays' | 'oneMonth' |
  'twoMonths' | 'threeMonths' | 'monthlyRecurring';
  storeId?: string;
}

interface Schedule {
  dayOfWeek: string;  // Name of the day (e.g., Monday, Tuesday)
  openTime: string | null;  // Opening time (e.g., "10:00:00"), or null if not available
  closeTime: string | null; // Closing time (e.g., "15:00:00"), or null if not available
  isActive: boolean;  // Indicates if the day is active or not
}

interface StoreTimingOverride {
  uuid: string;
  overrideType: 'HOLIDAY' | 'CUSTOM';
  status: 'CLOSED' | 'OPEN' | 'MODIFIED_HOURS';
  specificDate: string | null;
  startDate: string;
  endDate: string;
  openTime: string | null;
  closeTime: string | null;
  reason: string | null;
}

interface OwnItPricing {
  discountPercentage: number;
  purchasePrice: number;
}

interface quote {
  serviceCharge: number;
  deliveryCharge: number;
  depositCharge: number;
  orderValue: number;
  productDepositAmount: number;
  instoreCollectionCharge: number;
  productRates: [
    {
      productUuid: string;
      productRentalValue: number;
      productRetailValue: number;
      rentalTerm: number;
      productRate: number;
      productDepositAmount: number;
    }
  ];
  productUuid: string;
  productRentalValue: number;
  productRetailValue: number;
  rentalTerm: number;
  productRate: number;
  ownItPricing?: OwnItPricing;
}

// Parse specific store IDs from environment variable (comma-separated)
const SPECIFIC_STORE_IDS = (process.env.REACT_APP_SPECIFIC_STORE_IDS || "").split(",").map(id => id.trim()).filter(id => id.length > 0);

// Helper function to check if a store ID is in the specific stores list
const isSpecificStoreId = (storeId: string | undefined): boolean => {
  return storeId ? SPECIFIC_STORE_IDS.includes(storeId) : false;
};

interface TimeSlot {
  hour: number;
  minute: number;
  period: string;
  isEveningSlot?: boolean;
  slotType?: 'morning' | 'afternoon' | 'evening';
}

const getSpecificStoreTimeSlots = (productPricing: any, isHourlyEnabled: boolean): TimeSlot[] => {
  const baseSlots: TimeSlot[] = [
    { hour: 9, minute: 0, period: "A.M.", slotType: 'morning' }
  ];
  // Add 1:00 PM slot if either hourly is enabled OR eveningLong is available
  if (isHourlyEnabled || productPricing?.eveningLong > 0) {
    baseSlots.push({
      hour: 1,
      minute: 0,
      period: "P.M.",
      slotType: 'afternoon',
      isEveningSlot: productPricing?.eveningLong > 0
    });
  }

  // Add 5:00 PM if eveningShort is available and > 0
  if (productPricing?.eveningShort > 0) {
    baseSlots.push({
      hour: 5,
      minute: 0,
      period: "P.M.",
      slotType: 'evening',
      isEveningSlot: true
    });
  }

  return baseSlots;
};

const optionStart: OptionType[] = [];

const optionEnd: OptionType[] = [];

const monthOptionLabel = {
  ONE_MONTH_FIXED: "1 Month - fixed",
  TWO_MONTHS_FIXED: "2 Months - fixed",
  THREE_MONTHS_FIXED: "3 Months - fixed",
  FULLly_FLEXIBLE: `Flexible monthly rolling subscription`
} as const;

const monthOption: OptionType[] = [
  { value: "1", label: monthOptionLabel.ONE_MONTH_FIXED },
  { value: "2", label: monthOptionLabel.TWO_MONTHS_FIXED },
  { value: "3", label: monthOptionLabel.THREE_MONTHS_FIXED },
];

const allDayOptionsArray: OptionType[] = [
  { value: "1", label: dayOptionLabel.ONE_DAY, categoryType: 'daily', key: 'oneDay' },
  { value: "2", label: dayOptionLabel.TWO_DAYS, categoryType: 'daily', key: 'twoDays' },
  { value: "3", label: dayOptionLabel.THREE_DAYS, categoryType: 'daily', key: 'threeDays' },
  { value: "4", label: dayOptionLabel.FOUR_DAYS, categoryType: 'daily', key: 'fourDays' },
  { value: "5", label: dayOptionLabel.FIVE_DAYS, categoryType: 'daily', key: 'fiveDays' },
  { value: "6", label: dayOptionLabel.SIX_DAYS, categoryType: 'daily', key: 'sixDays' },
  { value: "7", label: dayOptionLabel.SEVEN_DAYS, categoryType: 'daily', key: 'sevenDays' },
  { value: "8", label: dayOptionLabel.EIGHT_DAYS, categoryType: 'daily', key: 'eightDays' },
  { value: "9", label: dayOptionLabel.NINE_DAYS, categoryType: 'daily', key: 'nineDays' },
  { value: "10", label: dayOptionLabel.TEN_DAYS, categoryType: 'daily', key: 'tenDays' },
  { value: "14", label: dayOptionLabel.TWO_WEEKS, categoryType: 'weekly', key: 'fourteenDays' },
  { value: "21", label: dayOptionLabel.THREE_WEEKS, categoryType: 'weekly', key: 'twentyoneDays' },
  { value: "28", label: dayOptionLabel.FOUR_WEEKS, categoryType: 'weekly', key: 'twentyeightDays' },
];

const formatDynamicEndOptions = (
  startHour: number,
  period: string,
  storeSchedule: any[],
  enabledHourlyTime: number[],
  calendarValue: Date,
  storeId?: string,
  timingOverrides?: StoreTimingOverride[]
): OptionType[] => {
  const result: OptionType[] = [];
  const currentStoreId = storeId;
  const isSpecificStore = isSpecificStoreId(currentStoreId);

  // Get the day of the week from the calendarValue
  const dayOfWeek = calendarValue.toLocaleDateString("en-US", { weekday: "long" });

  // Find the schedule for the given day
  const scheduleForDay = storeSchedule.find(schedule => schedule.dayOfWeek === dayOfWeek);

  // Resolve any timing override for this specific date.
  // Use local date parts (not toISOString) to avoid UTC-offset shifting the date in BST/CET etc.
  const calIso = `${calendarValue.getFullYear()}-${String(calendarValue.getMonth() + 1).padStart(2, '0')}-${String(calendarValue.getDate()).padStart(2, '0')}`;
  const activeOverride = timingOverrides?.find(o => {
    if (!o.startDate || !o.endDate) return false;
    const start = o.startDate.split("T")[0];
    const end = o.endDate.split("T")[0];
    return calIso >= start && calIso <= end;
  });

  if (activeOverride?.status === 'CLOSED') return result;

  const effectiveCloseTime =
    (activeOverride?.status === 'OPEN' || activeOverride?.status === 'MODIFIED_HOURS') && activeOverride.closeTime
      ? activeOverride.closeTime
      : scheduleForDay?.closeTime;
  const isEffectivelyActive =
    activeOverride?.status === 'OPEN' || activeOverride?.status === 'MODIFIED_HOURS'
      ? true
      : scheduleForDay?.isActive;

  if (!isEffectivelyActive || !effectiveCloseTime) {
    return result;
  }



  // Parse the time string (e.g., "9:30 AM" or "2:00 PM")
  const timeMatch = period.match(/(\d{1,2}):(\d{2}) ([AP]M)/i);
  if (!timeMatch) {

    return result;
  }

  const [_, hourStr, minuteStr, periodIndicator] = timeMatch;
  let hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);
  const isPM = periodIndicator.toUpperCase().startsWith('P');

  // Convert to 24-hour format
  if (isPM && hour < 12) hour += 12;
  if (!isPM && hour === 12) hour = 0;

  const startMinutes = hour * 60 + minute;

  // Get close time in minutes since midnight
  const [closeHour, closeMin] = effectiveCloseTime.split(":").map(Number);
  const closeMinutes = closeHour * 60 + closeMin;



  // Define the standard rental durations in hours (1, 2, 4 hours)
  const standardDurations = [1, 2, 3, 4];

  // Only use durations that are enabled in the system
  const enabledDurations = standardDurations.filter(duration =>
    enabledHourlyTime.includes(duration)
  ).sort((a, b) => a - b);

  // Calculate time until close and filter durations that fit
  const timeUntilClose = closeMinutes - startMinutes;
  let filteredDurations = enabledDurations.filter(duration =>
    (duration * 60) <= timeUntilClose
  );


  if (isSpecificStore) {
    // For specific stores, check if it's 5:00 PM with store closing after 8 PM
    // In that case, exclude all durations since we're adding 3:30 hours separately
    const isPMFiveHours = hour === 17; // 5:00 PM in 24-hour format
    const isPMOneHour = hour === 13;   // 1:00 PM
    const isStoreOpenAfterEightPM = closeMinutes > (20 * 60); // 8:00 PM = 20:00

    // For 1:00 PM, exclude the 3-hour option as we'll handle it in the main component
    // if (isPMOneHour) {
    //   filteredDurations = filteredDurations.filter(d => d !== 3);
    // }

    if (isPMFiveHours && isStoreOpenAfterEightPM) {
      // Exclude all durations (1, 2, 3, 4) for 5:00 PM when store closes after 8 PM
      filteredDurations = [];
    } else {
      // Normal case: only return 3 hours
      filteredDurations = filteredDurations.filter(duration => { return duration === 3 });
    }
  }



  // Generate end time options for filtered durations
  filteredDurations.forEach(duration => {
    // Calculate end time in minutes (duration is in hours)
    const endMinutes = startMinutes + (duration * 60);

    // Only add if end time is before or equal to close time
    if (endMinutes <= closeMinutes) {
      const endHour24 = Math.floor(endMinutes / 60) % 24;
      // Preserve the minutes from the start time
      const endMinute = minute; // Use the same minute as start time
      const endHour12 = endHour24 % 12 || 12;
      const endPeriod = endHour24 >= 12 ? 'P.M.' : 'A.M.';

      // Format duration text
      const durationText = `${duration} hour${duration > 1 ? 's' : ''}`;

      // Format time with leading zeros
      const formattedHour = endHour12 < 10 ? `0${endHour12}` : endHour12;
      const formattedMinute = endMinute < 10 ? `0${endMinute}` : endMinute;

      // Determine the option key based on duration
      let key: any;

      if (duration === 1) key = 'oneHour';
      else if (duration === 2) key = 'twoHours';
      else if (duration === 3) key = 'threeHours';
      else if (duration === 4) key = 'fourHours';
      const option: OptionType = {
        value: endMinutes.toString(),
        // label: isSpecificStore ? `${(formattedHour === 12) ? "Morning" : "Afternoon"} (${formattedHour}:${formattedMinute} ${endPeriod})` : `${(isSpecificStore && formattedHour === 12) ? "Morning" : ""} ${formattedHour}:${formattedMinute} ${endPeriod} (${duration} hr${duration > 1 ? 's' : ''})`,

        label: `${formattedHour}:${formattedMinute} ${endPeriod} (${duration} hr${duration > 1 ? 's' : ''})`,
        key: key,
        categoryType: 'hourly'
      };

      result.push(option);
    }
  });

  return result;
};


const optionTimeTo24h = (optionValue: string): string => {
  const parts = optionValue.split(' ');
  if (parts.length < 2) return '';
  const [timePart, periodPart] = parts;
  const [h, m] = timePart.split(':').map(Number);
  const period = periodPart.replace(/\./g, '').toUpperCase();
  let hour24 = h;
  if (period === 'PM' && h !== 12) hour24 = h + 12;
  else if (period === 'AM' && h === 12) hour24 = 0;
  return `${String(hour24).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};

const formatDate = (date: Date | null) => {
  if (!date) return ["", ""];
  const firstPart = format(date, "dd MMM,");
  const secondPart = format(date, "EEE, yy");
  return [firstPart, secondPart];
};

const FormattedDateComponent: React.FC<{ date: Date | null }> = ({ date }) => {
  const [firstPart, secondPart] = formatDate(date);
  return (
    <p>
      {firstPart} <span>{secondPart}</span>
    </p>
  );
};

const CalendarModal: React.FC<CalendarModalProps> = ({
  onHide,
  onDateSelect,
  getQuoteData,
  openAddOnModal,
  setQuoteProductData,
  ...props
}) => {
  const [modalSize, setModalSize] = useState<"sm" | "lg" | "xl" | undefined>(
    "lg"
  );
  const [enabledHourlyPrices, setEnabledHourlyPrices] = useState<number[]>([]);
  const { setBaseProductUuidForAddOn } = useAuth();

  const handleResize = () => {
    if (window.innerWidth < 576) {
      setModalSize("sm");
    } else if (window.innerWidth < 1399) {
      setModalSize("lg");
    } else {
      setModalSize("lg");
    }
  };
  const filterEnabledHorlyTime = (data: any) => {
    const duration: any = [];
    if (data) {
      Object.entries(data).map(([key, value]) => {
        if (key === 'oneHour' && value !== 0) {
          if (props?.commonProductPricing) {
            const foundKey = props?.commonProductPricing.find((k: any) => k === key);
            if (foundKey) {
              duration.push(1);
            }
          } else {
            duration.push(1);
          }
        }
        if (key === 'twoHours' && value !== 0) {
          if (props?.commonProductPricing) {
            const foundKey = props?.commonProductPricing.find((k: any) => k === key);
            if (foundKey) {
              duration.push(2);
            }
          } else {
            duration.push(2);
          }
        }
        if (key === 'threeHours' && value !== 0) {
          if (props?.commonProductPricing) {
            const foundKey = props?.commonProductPricing.find((k: any) => k === key);
            if (foundKey) {
              duration.push(3);
            }
          } else {
            duration.push(3);
          }
        }
        if (key === 'fourHours' && value !== 0) {
          if (props?.commonProductPricing) {
            const foundKey = props?.commonProductPricing.find((k: any) => k === key);
            if (foundKey) {
              duration.push(4)
            }
          } else {
            duration.push(4)
          }
        }
        if (key === 'oneDay' && value !== 0) {
          if (props?.commonProductPricing) {
            const foundKey = props?.commonProductPricing.find((k: any) => k === key);
            if (foundKey) {
              duration.push(8)
            }
          } else {
            duration.push(8)
          }
        }
      })
      return duration;
    }
  }

  const filterMonthlyPrices = (data: any) => {
    const monthOption: OptionType[] = [];
    if (data) {
      Object.entries(data).map(([key, value]) => {
        if (key === 'oneMonth' && value !== 0) {
          if (props?.commonProductPricing) {
            const foundKey = props?.commonProductPricing.find((k: any) => k === key);
            if (foundKey) {
              monthOption.push({ value: "1", label: monthOptionLabel.ONE_MONTH_FIXED });
            }
          } else {
            monthOption.push({ value: "1", label: monthOptionLabel.ONE_MONTH_FIXED });
          }
        }
        if (key === 'twoMonths' && value !== 0) {
          if (props?.commonProductPricing) {
            const foundKey = props?.commonProductPricing.find((k: any) => k === key);
            if (foundKey) {
              monthOption.push({ value: "2", label: monthOptionLabel.TWO_MONTHS_FIXED });
            }
          } else {
            monthOption.push({ value: "2", label: monthOptionLabel.TWO_MONTHS_FIXED });
          }
        }
        if (key === 'threeMonths' && value !== 0) {
          if (props?.commonProductPricing) {
            const foundKey = props?.commonProductPricing.find((k: any) => k === key);
            if (foundKey) {
              monthOption.push({ value: "3", label: monthOptionLabel.THREE_MONTHS_FIXED })
            }
          }
          else {
            monthOption.push({ value: "3", label: monthOptionLabel.THREE_MONTHS_FIXED })
          }
        }
      })
      return monthOption;
    }
    return monthOption;
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize(); // Initial call to set the size based on the initial window size
    handleDateChange([new Date(), new Date()], "one");
    setCalendarValue(new Date());
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  //
  // Time Dropdown Start
  const [storeSchedule, setStoreSchedule] = useState<Schedule[]>([]);
  const [timingOverrides, setTimingOverrides] = useState<StoreTimingOverride[]>([]);
  const [inactiveDays, setInactiveDays] = useState<string[]>([]);
  const [returnEndDate, setReturnEndDate] = useState('');
  const [startTime, setStartTime] = useState<OptionType | null>(null);
  const [endTime, setEndTime] = useState<OptionType | null>(null);
  const [filteredOptions, setFilteredOptions] = useState(optionStart);
  const [endTimeOptions, setEndTimeOptions] = useState<OptionType[]>(optionEnd);
  const [dayOptions, setDayOptions] = useState<OptionType[]>([]);
  const [dayOptionsArray, setDayOptionsArray] = useState<OptionType[]>([]);
  const [selectedDay, setSelectedDay] = useState<OptionType | any>(null);
  const [monthOptions, setMonthOptions] = useState<OptionType[]>(monthOption);
  const [selectedMonth, setSelectedMonth] = useState<OptionType | any>(null);
  const [rentPrice, setRentPrice] = useState<number | null>(null);
  const [productRate, setProductRate] = useState<number | null>(null);
  const [productRentalValue, setProductRentalValue] = useState<number | null>(null);
  const [productRetailValue, setProductRetailValue] = useState<number | null>(null);
  const [quateCharges, setQuateCharges] = useState<quote>();
  const [isFocused, setIsFocused] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMultipleDaysDisabled, setIsMultipleDaysDisabled] =
    useState<boolean>(false);
  const [isDayOrLessDisabled, setIsDayOrLessDisabled] =
    useState<boolean>(false);
  const [isMonthlyDisabled, setIsMonthlyDisabled] =
    useState<boolean>(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false); // State to disable button based on date validation
  const [isStartDateDisabled, setIsStartDateDisabled] =
    useState<boolean>(false);
  const [isProductAvailable, setIsProductAvailable] = useState(false);
  const [isProductEnabled, setIsProductEnabled] = useState(false);
  const [editProductData, setEditProductData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const handleFocus = () => {
    setIsFocused(true);
  };
  const handleBlur = () => {
    setIsFocused(startTime !== null);
  };
  const handleMenuOpen = () => {
    setIsMenuOpen(true);
  };
  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };
  // Time Dropdown End

  const isDailySelectedDateInRange = () => {
    const [start, end] = dateRange;
    return (start && end) ? true : false;
  };

  const navigate = useNavigate();
  const { customerUuid, quoteId } = getAuthCredentials();
  const [disabledDates, setDisabledDates] = useState<any>([]);
  const [disableddHours, setDisabledHours] = useState<any>([]);
  const [blockedHourlySlots, setBlockedHourlySlots] = useState<string[]>([]);
  const [hourlyBlockedDateRanges, setHourlyBlockedDateRanges] = useState<{ start_date: string; end_date: string }[]>([]);
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    new Date(),
    new Date(),
  ]);
  const [isRangeCleared, setIsRangeCleared] = useState(isDailySelectedDateInRange());
  const [fullDayValue, setFullDayValue] = useState("");
  const [recommendedProductsCount, setRecommendedProductsCount] = useState(0);
  // Utility function to check if a selected date is disabled
  const isSelectedDateDisabled = (): boolean => {
    const selectedDate: any = dateRange[0];
    return disabledDates.some((range: any) => {
      const startDate = new Date(range.startDate);
      const endDate = new Date(range.endDate);
      return (
        isAfter(selectedDate, startDate) && isBefore(selectedDate, endDate)
      );
    });
  };
  useEffect(() => {
    const productDetails = props?.details?.edit ? props.details.productDetailsByUUID : props.details;
    if (
      ((props?.details?.dailyChecked === false &&
        props?.details?.weeklyChecked === false) || (productDetails?.dailyChecked === false && productDetails?.weeklyChecked === false))
    ) {
      setIsMultipleDaysDisabled(true);
    } else {
      setIsMultipleDaysDisabled(false);
    }
  }, [props]);


  useEffect(() => {
    const productDetails = props?.details?.edit ? props?.details.productDetailsByUUID : props.details;
    const hasCustomPricing = props?.productpricing?.isCustomPricing === true ||
      props?.productpricing?.eveningLong ||
      props?.productpricing?.eveningShort;

    // If there's custom pricing, always enable hourly tab
    if (hasCustomPricing) {
      setIsDayOrLessDisabled(false);
    }
    // Otherwise, respect the hourlyChecked flag
    else if (props?.details?.hourlyChecked === false || productDetails?.hourlyChecked === false) {
      setIsDayOrLessDisabled(true);
    } else {
      setIsDayOrLessDisabled(false);
    }
  }, [props, props?.productpricing]);

  useEffect(() => {
    if (props?.details?.storeDetails?.storeSchedule) {
      setStoreSchedule(props?.details?.storeDetails?.storeSchedule);
      setInactiveDays(getInactiveDays(props?.details?.storeDetails?.storeSchedule ?? []))
    }
    if (props?.details?.storeDetails?.storeTimingOverrides) {
      setTimingOverrides(props.details.storeDetails.storeTimingOverrides);
    }
  }, [props.details]);

  useEffect(() => {
    if (props?.productpricing) {
      setEnabledHourlyPrices(filterEnabledHorlyTime(props?.productpricing));
    }
  }, [props?.productpricing])

  useEffect(() => {
    if (props?.details?.monthlyChecked === false) {
      setIsMonthlyDisabled(true);
    } else {
      setIsMonthlyDisabled(false);
    }
    if (props?.details?.monthlyRecurringChecked) {
      setIsMonthlyDisabled(false);
    }
    if (props?.details?.monthlyRecurringChecked && props?.details?.monthlyChecked) {
      const filteredMonths = filterMonthlyPrices(props?.productpricing);
      setMonthOptions([{ value: '12', label: monthOptionLabel.FULLly_FLEXIBLE }, { value: "", label: "Or Fixed term", isDisabled: true }, ...filteredMonths])
    } else if (props?.details?.monthlyRecurringChecked) {
      setMonthOptions([{ value: '12', label: monthOptionLabel.FULLly_FLEXIBLE }])
    } else {
      setMonthOptions(filterMonthlyPrices(props?.productpricing));
    }

    let dailyArray: OptionType[] = [];
    let weeklyArray: OptionType[] = [];

    // Include daily options if dailyChecked is explicitly true
    if (props?.details?.dailyChecked === true) {
      dailyArray = allDayOptionsArray.filter(row => {
        const key = row.key ?? '';
        if (props?.commonProductPricing) {
          const foundKey = props?.commonProductPricing.find((k: any) => k === key);
          return row.categoryType === 'daily' && !!foundKey;
        } else {
          return row.categoryType === 'daily' && !!props.productpricing[key];
        }
      });
    }

    // Include weekly options if weeklyChecked is explicitly true
    if (props?.details?.weeklyChecked === true) {
      weeklyArray = allDayOptionsArray.filter(row => {
        const key = row.key ?? ''
        if (props?.commonProductPricing) {
          const foundKey = props?.commonProductPricing.find((k: any) => k === key);
          return row.categoryType === 'weekly' && !!foundKey;
        } else {
          return row.categoryType === 'weekly' && !!props.productpricing[key];
        }
      });
    }

    // Combine both daily and weekly options for the daily tab dropdown
    const filteredDayOptionsArray: OptionType[] = [...dailyArray, ...weeklyArray];
    setDayOptionsArray(filteredDayOptionsArray);

  }, [props?.details]);

  const getLocalDate = (date: any) => {

    const localDate =
      date && date?.getTime() - date?.getTimezoneOffset() * 60000;
    const localDateString = localDate && new Date(localDate);
    return localDateString;
  };

  // Returns start/end Date objects for a Full Day booking using actual store hours.
  // If the date is today, the start is the next full hour (e.g. 1:23 PM → 2:00 PM).
  // For specific stores on Wednesday, always returns 9:00 AM – 4:00 PM.
  const getFullDayDateRange = (date: Date): { startDate: Date; endDate: Date } => {
    const currentStoreId = props?.details?.storeUuid || props?.storeDetails?.uuid;
    const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "long" });
    if (isSpecificStoreId(currentStoreId) && dayOfWeek === 'Wednesday') {
      const startDate = new Date(date);
      startDate.setHours(9, 0, 0, 0);
      const endDate = new Date(date);
      endDate.setHours(16, 0, 0, 0);
      return { startDate, endDate };
    }
    const scheduleForDay = storeSchedule.find((s: Schedule) => s.dayOfWeek === dayOfWeek);
    const isoDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    const activeOverride = timingOverrides?.find((o: StoreTimingOverride) => {
      const start = o.startDate.split('T')[0];
      const end = o.endDate.split('T')[0];
      return isoDate >= start && isoDate <= end;
    });
    const effectiveOpenTime =
      (activeOverride?.status === 'OPEN' || activeOverride?.status === 'MODIFIED_HOURS') && activeOverride.openTime
        ? activeOverride.openTime
        : scheduleForDay?.openTime;
    const effectiveCloseTime =
      (activeOverride?.status === 'OPEN' || activeOverride?.status === 'MODIFIED_HOURS') && activeOverride.closeTime
        ? activeOverride.closeTime
        : scheduleForDay?.closeTime;
    const [openH, openM] = effectiveOpenTime ? effectiveOpenTime.split(':').map(Number) : [9, 0];
    const [closeH, closeM] = effectiveCloseTime ? effectiveCloseTime.split(':').map(Number) : [17, 0];
    const now = new Date();
    const isToday = date.toLocaleDateString() === now.toLocaleDateString();
    let startHour = openH;
    let startMinute = openM;
    if (isToday) {
      // Next full hour: e.g. 1:23 PM → 2:00 PM
      const nextHour = now.getHours() + 1;
      startHour = Math.max(nextHour, openH);
      startMinute = 0;
    }
    const startDate = new Date(date);
    startDate.setHours(startHour, startMinute, 0, 0);
    const endDate = new Date(date);
    endDate.setHours(closeH, closeM, 0, 0);
    return { startDate, endDate };
  };

  useEffect(() => {
    const today = new Date();
    const todayDisabled = disabledDates.some((range: any) => {
      const startDate = new Date(range.startDate);
      const endDate = new Date(range.endDate);
      return isAfter(today, startDate) && isBefore(today, endDate);
    });
    setIsButtonDisabled(todayDisabled);
    if (startTime && endTime) {
      if (endTime.value === "Full Day") {
        // Apply store open/close times (or next-hour for today) so calculateRentPrice
        // sends the correct bookingStartDate/bookingEndDate to the API.
        const { startDate, endDate } = getFullDayDateRange(dateRange[0] ?? new Date());
        dateRange[0] = startDate;
        dateRange[1] = endDate;
        setStartTime(null);
        setEndTime(null);
        setFullDayValue("Full Day");
      } else {
        changesEndTime();
      }

      calculateRentPrice();
    } else {
      const selectedDate: any = dateRange[0];
      const isSelectedDisabled = disabledDates.some((range: any) => {
        const startDate = new Date(range.startDate);
        const endDate = new Date(range.endDate);
        return (
          isAfter(selectedDate, startDate) && isBefore(selectedDate, endDate)
        );
      });
      setIsStartDateDisabled(isSelectedDisabled);
      if (!!fullDayValue && !isSelectedDisabled) {
        setIsButtonDisabled(false);
        const { startDate: fdStart, endDate: fdEnd } = getFullDayDateRange(dateRange[0] ?? new Date());
        dateRange[0] = fdStart;
        dateRange[1] = fdEnd;
      } else {
        setIsButtonDisabled(true);
      }
    }
  }, [disabledDates, startTime, endTime, props?.details?.productPrice]);

  const calculateRentPrice = async () => {
    if (!startTime || !endTime) {
      return;
    }

    // Calculate actual time difference for 1, 2, or 4 hours
    const start = dateRange[0]!;
    const end = dateRange[1]!;
    const diffInMs = end.getTime() - start.getTime();
    const diffInHours = (diffInMs / (1000 * 60 * 60) === 7.5 || diffInMs / (1000 * 60 * 60) === 3.5) ? diffInMs / (1000 * 60 * 60) : Math.ceil(diffInMs / (1000 * 60 * 60));
    let hourSelectedValue: number | string | undefined;
    const rentalType = endTime.value == "Full Day" ? "daily" : "hourly";

    // For 1, 2, 3, or 4 hours, use actual time difference
    if (diffInHours === 1 || diffInHours === 2 || diffInHours === 3 || diffInHours === 4 || diffInHours === 3.5 || diffInHours === 7.5) {
      if (endTime.value === "Full Day") {
        hourSelectedValue = 1;
      } else {
        hourSelectedValue = diffInHours;
      }
    } else {
      // For other cases, use the original logic
      const match = endTime.value.match(/(\d+)\s*hr?s/);
      const hours = match ? parseInt(match[1], 10) : 1;

      if (hours === 1) {
        hourSelectedValue = "1";
      } else if (hours === 2) {
        hourSelectedValue = "2";
      } else if (hours === 3) {
        hourSelectedValue = "3";
      } else if (hours === 4) {
        hourSelectedValue = "4";
      }
      if (endTime.value === "Full Day") {
        hourSelectedValue = 1;
      }
    }
    const id = props?.productuuid ?? props?.details?.productUuid;
    let request: any;
    if (props?.details?.edit) {
      const products = props?.details?.productDetails.map((item: any) => ({
        productUuid: item.productUuid,
        retailerUuid: item?.retailerUuid,
        storeUuid: item?.storeUuid,
        rentalDuration: Number(hourSelectedValue) || 0, // rental duration,
        quantity: item?.productQuantity ? item?.productQuantity : 1,
        productQuantity: props.selectedQuantity || 1, // Add selected quantity to the request
        rentalType: rentalType,
        bookingDate: {
          bookingStartDate: getLocalDate(dateRange[0]).toISOString(),
          bookingEndDate: getLocalDate(dateRange[1]).toISOString(),
        },
        productVariantUuid: item?.productVariantUuid,
        productRetailValue: item?.productRetailValue,
        option1: item?.option1,
        option2: item?.option2,
        option3: item?.option3,
      }));
      request = { products: products };
    } else {

      request = {
        products: [
          {
            baseProductUuidForAddOn: props?.productuuid,
            productUuid: id,
            retailerUuid: props?.details?.retailerUuid,
            storeUuid: props?.details?.storeUuid,
            rentalDuration: Number(hourSelectedValue) || 0, // rental duration,
            quantity: props.selectedQuantity || 1, // Use selected quantity from props
            productQuantity: props.selectedQuantity || 1, // Add selected quantity to the request
            rentalType: rentalType,
            bookingDate: {
              bookingStartDate: getLocalDate(dateRange[0])?.toISOString(),
              bookingEndDate: getLocalDate(dateRange[1])?.toISOString(),
            },
            productVariantUuid: props?.productVariantUuid,
            ...quoteId && { previousQuoteUuid: quoteId },
            ...(props?.variantOptions || {}) // Include variant options if available
          },
        ],
      };
    }
    setIsLoading(true);
    await productDetailsClient
      .getQuotesCharges(request)
      .then(async (data: any) => {
        setRentPrice(data.orderValue);
        setIsLoading(false);
        setIsProductAvailable(data?.productAvailibility);
        setIsProductEnabled(data?.updateQuoteProduct);
        setRecommendedProductsCount(data?.addOnProductCount ?? 0);
        setProductRetailValue(data?.productRetailValue);
        if (!data.updateQuoteProduct || !data.productAvailibility) {
          // Only reset times if not in hourly tab to maintain selection
          if (activeTab !== 'hourly') {
            setStartTime(null);
            setEndTime(null);
          }

          if (data?.productRates?.length > 1) {
            const filteredProductNames = data?.productRates
              .filter((product: any) => !product?.updateQuoteProduct)
              .map((product: any) => product?.productName);
            toast.error(
              `The following items are not available for your selected ${activeTab === 'hourly' ? 'time' : 'dates'}: ${filteredProductNames.join(
                ", "
              )}. Please try a different ${activeTab === 'hourly' ? 'time' : 'date'}.`
            );
          } else {
            if (!data.productAvailibility) {
              if (activeTab === 'hourly') {
                toast.error("This item is not available for the selected time. Please try a different time.");
              } else if (data.productRates[0]?.error) {
                toast.error(data.productRates[0]?.error);
              } else {
                toast.error("This item is not available on the selected dates.");
              }
            } else if (
              data.productRates[0]?.dailyChecked &&
              !data.productRates[0]?.weeklyChecked
            ) {
              toast.success(
                "The maximum Rental duration for this item is 6 days, please re-select your dates."
              );
            } else if (
              !data.productRates[0]?.dailyChecked &&
              data.productRates[0]?.weeklyChecked
            ) {
              toast.success(
                "The minimal Rental duration for this item is 7 days, please re-select your dates."
              );
            } else {
              toast.error("Something went wrong.");
            }
          }
        }
        if (props?.details?.edit) {
          if (data.productAvailibility) {
            const productData = data.productRates.map((proData: any) => ({
              productRentalTerm: proData.rentalTerm,
              productRate: proData.productRate,
              productDepositAmount: proData?.productDepositAmount,
              productQuantity: proData?.quantity ? proData?.quantity : 1,
              productRentalPrice: proData?.productRentalValue,
              productRetailValue: proData?.productRetailValue,
              productUuid: proData?.productUuid,
              productName: "",
              bookingDate: request?.products[0]?.bookingDate,
              productVariantUuid: proData?.productVariantUuid,
              option1: proData?.option1,
              option2: proData?.option2,
              option3: proData?.option3,
            }));

            const mergedArray = productData.map((item1: any) => {
              const match = props?.details?.productDetails?.find(
                (item2: any) => item2.productUuid === item1.productUuid && item2.productVariantUuid === item1.productVariantUuid
              );
              let dateRangeUpdated = checkAndGetNextActiveDay();
              return match
                ? {
                  ...item1,
                  productName: match?.productName,
                  bookingDate: {
                    bookingStartDate: getLocalDate(
                      dateRangeUpdated[0]
                    ).toISOString(),
                    bookingEndDate: getLocalDate(dateRangeUpdated[1]).toISOString(),
                  },
                  productVariantUuid: match?.productVariantUuid,
                  productRetailValue: match?.productRetailValue,
                  option1: match?.option1,
                  option2: match?.option2,
                  option3: match?.option3,
                }
                : item1;
            });

            const requestData = {
              products: mergedArray,
              quoteTotal: data?.orderValue,
              depositAmount: data?.depositCharge,
              serviceCharge: data?.serviceCharge,
              // deliveryCharge: data?.instoreCollectionCharge,
              deliveryCharge: data?.deliveryCharge,
              instoreCollectionCharge: data?.instoreCollectionCharge,
              storeUuid: props?.details?.storeUuid,
              rentalType: rentalType,
              retailerUuid: props?.details?.retailerUuid,
              rentalDuration: Number(hourSelectedValue) || 0, // rental duration, 
            };

            setEditProductData(requestData);
          } else {
            toast.success("Product is not available on selected date.");
            // setToastMessage("Product is not available on selected date.");
            // setShowToast(true);
            // setToastType("danger");
          }
        } else {
          const productPrice = data.productRates.filter(
            (data: any) => props?.details?.uuid == data.productUuid
          )[0];

          setProductRate(productPrice.productRate);
          setProductRetailValue(productPrice.productRetailValue);
          setQuateCharges(data);
        }
      })
      .catch((error) => {
        toast.error(error?.message);
      });
  };

  const formatTime = (isoString: any) => {
    const date = new Date(isoString);
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "P.M" : "A.M";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    return `${hours}:${minutes} ${ampm}`;
  };

  const updateDatesToMidnight = (data: any) => {
    return data.map((entry: any) => {
      // Extract date part from startDate and endDate
      const startDate = entry.startDate.split("T")[0];
      const endDate = entry.endDate.split("T")[0];

      return {
        ...entry,
        startDate: `${startDate}T00:00:00.000Z`,
        endDate: `${endDate}T00:00:00.000Z`,
      };
    });
  };

  function isTodayNotInRange(dateRanges: any): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Normalize to midnight

    const isInRange = dateRanges.some((range: any) => {
      const start = new Date(range.startDate);
      const end = new Date(range.endDate);
      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);

      return today >= start && today <= end;
    });

    // Only update date if modal is shown and not in the process of closing
    if (!isInRange && props.show) {
      handleDateChange([new Date(), new Date()], "one");
    }

    return !isInRange;
  }

  // Function to fetch booking dates with current quantity
  const fetchBookingDates = () => {
    if (
      (props?.productuuid || props.details?.productUuid) &&
      (props?.productVariantUuid || props.details?.productVariantUuid) &&
      !props?.details?.edit &&
      (!quoteId || quoteId === "")
    ) {
      const id = props?.productuuid ?? props?.details?.productUuid;
      setBaseProductUuidForAddOn(id);

      const productVariantUuid = props?.productVariantUuid ?? props?.details?.productVariantUuid;
      const quantity = props.selectedQuantity || 1;

      productDetailsClient
        .getBookingDate({
          productUuid: id,
          productVariantUuid: productVariantUuid,
          productQuantity: quantity // Include the selected quantity
        })
        .then((response: any) => {
          const data = response?.data;

          if (data) {
            const dates = data;
            const filterDates = dates
              .filter((dateDetails: any) => {
                return new Date(dateDetails.end_date) > new Date();
              })
              .map((selectedDate: any) => {
                const today = new Date();
                const yesterday = new Date(today);
                yesterday.setDate(today.getUTCDate());
                return {
                  startDate:
                    new Date(selectedDate.start_date) < new Date()
                      ? yesterday?.toISOString()
                      : new Date(selectedDate?.start_date)?.toISOString(),
                  endDate: new Date(selectedDate?.end_date)?.toISOString(),
                };
              });

            const disabledDateData = updateDatesToMidnight(filterDates);
            setDisabledDates(disabledDateData);
            isTodayNotInRange(filterDates);
            setDisabledHours([]);
          }
        })
        .catch((error) => {
          console.error('Error fetching booking dates:', error);
        });
    }
  };

  const fetchHourlyBlockedSlots = (date: Date) => {
    const id = props?.productuuid ?? props?.details?.productUuid;
    const productVariantUuid = props?.productVariantUuid ?? props?.details?.productVariantUuid;
    if (!id || !productVariantUuid) return;

    const y = date.getFullYear();
    const mo = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const dateStr = `${y}-${mo}-${d}`;

    setBlockedHourlySlots([]);
    productDetailsClient.getBookingDate({
      productUuid: id,
      productVariantUuid: productVariantUuid,
      productQuantity: props.selectedQuantity || 1,
      date: dateStr,
      // rentalType: 'hourly',
    }).then((response: any) => {
      const hourly: string[] = response?.data?.hourly ?? [];
      setBlockedHourlySlots(hourly);
      const dateRanges: { start_date: string; end_date: string }[] = response?.data?.date_ranges ?? [];
      setHourlyBlockedDateRanges(prev => {
        const prevStr = JSON.stringify(prev);
        const newStr = JSON.stringify(dateRanges);
        return prevStr === newStr ? prev : dateRanges;
      });
    }).catch(() => {
      setBlockedHourlySlots([]);
    });
  };

  // Initial fetch of booking dates
  useEffect(() => {
    fetchBookingDates();
  }, [props?.productuuid, props.details?.productUuid, props?.productVariantUuid, props?.details?.productVariantUuid, quoteId, storeSchedule]);

  // Initial fetch of date_ranges to block dates on all tabs from the start
  useEffect(() => {
    fetchHourlyBlockedSlots(new Date());
  }, [props?.productuuid, props.details?.productUuid, props?.productVariantUuid, props?.details?.productVariantUuid]);

  // Refetch booking dates when quantity changes
  useEffect(() => {
    fetchBookingDates();
    setHourlyBlockedDateRanges([]);
    fetchHourlyBlockedSlots(calendarValue || new Date());
  }, [props.selectedQuantity]);

  // Fetch hourly blocked slots whenever the hourly tab is active
  useEffect(() => {
    if (activeTab === 'hourly') {
      fetchHourlyBlockedSlots(calendarValue || new Date());
    } else {
      setBlockedHourlySlots([]);
    }
  }, [activeTab]);

  // ---------------------------------------------------------------------------
  // FIX: Re-populate filteredOptions (start time slots) for the hourly tab
  // whenever storeSchedule becomes available or activeTab switches to 'hourly'.
  // Previously, the auto-selection of today's date happened before storeSchedule
  // was loaded, so filteredOptions remained empty until the user manually clicked
  // the same date again. Now we recompute them as soon as we have both pieces.
  // ---------------------------------------------------------------------------
  useEffect(() => {
    if (activeTab === 'hourly' && storeSchedule && storeSchedule.length > 0) {
      const targetDate = calendarValue || new Date();
      const currentStoreId = props?.details?.storeUuid || props?.storeDetails?.uuid;
      const isSpecificStore = isSpecificStoreId(currentStoreId);

      const filterTimesForDate = (selectedDate: Date): OptionType[] => {
        const dayOfWeek = selectedDate.toLocaleDateString("en-US", { weekday: "long" });
        const scheduleForDay = storeSchedule.find(schedule => schedule.dayOfWeek === dayOfWeek);
        const override = getOverrideForDate(selectedDate);
        if (override?.status === 'CLOSED') return [];
        const effectiveOpenTime = (override?.status === 'OPEN' || override?.status === 'MODIFIED_HOURS') && override.openTime ? override.openTime : scheduleForDay?.openTime;
        const effectiveCloseTime = (override?.status === 'OPEN' || override?.status === 'MODIFIED_HOURS') && override.closeTime ? override.closeTime : scheduleForDay?.closeTime;
        const isEffectivelyActive = (override?.status === 'OPEN' || override?.status === 'MODIFIED_HOURS') ? true : scheduleForDay?.isActive;

        if (!isEffectivelyActive || !effectiveOpenTime || !effectiveCloseTime) {
          return [];
        }

        if (isSpecificStore) {
          const isToday = selectedDate.toLocaleDateString() === new Date().toLocaleDateString();
          const currentTimeMinutes = new Date().getHours() * 60 + new Date().getMinutes();
          const options: OptionType[] = [];

          const specificStoreTimeSlots = getSpecificStoreTimeSlots(props?.productpricing, props?.details?.hourlyChecked);
          specificStoreTimeSlots.forEach(slot => {
            let hour24 = slot.hour;
            if (slot.period === "P.M." && slot.hour !== 12) {
              hour24 = slot.hour + 12;
            } else if (slot.period === "A.M." && slot.hour === 12) {
              hour24 = 0;
            }

            const slotMinutes = hour24 * 60 + slot.minute;

            if (slot.hour === 5 && slot.period === "P.M.") {
              if (effectiveCloseTime) {
                const [closeHour, closeMinute] = effectiveCloseTime.split(":").map(Number);
                const closeTimeInMinutes = closeHour * 60 + closeMinute;
                const eightPMInMinutes = 20 * 60;
                if (closeTimeInMinutes < eightPMInMinutes) {
                  return;
                }
              } else {
                return;
              }
            }

            const SLOT_CUTOFFS: Record<string, number> = {
              "09:00 A.M.": 12 * 60,
              "01:00 P.M.": 16 * 60,
              "05:00 P.M.": 20 * 60,
            };

            const slotKey = `${String(slot.hour).padStart(2, "0")}:${String(slot.minute).padStart(2, "0")} ${slot.period}`;
            const cutoff = SLOT_CUTOFFS[slotKey] ?? slotMinutes;

            if (!isToday || currentTimeMinutes < cutoff) {
              const formattedHour = slot.hour < 10 ? `0${slot.hour}` : slot.hour;
              const formattedMinute = slot.minute < 10 ? `0${slot.minute}` : slot.minute;
              const label = `${formattedHour}:${formattedMinute} ${slot.period}`;
              const value = `${formattedHour}:${formattedMinute} ${slot.period}`;
              options.push({ value, label });
            }
          });

          return options;
        }

        const [openHour24, openMinute] = effectiveOpenTime.split(":").map(Number);
        const [closeHour24, closeMinute] = effectiveCloseTime.split(":").map(Number);
        const openMinutes = Math.ceil((openHour24 * 60 + openMinute) / 15) * 15;
        const closeMinutes = closeHour24 * 60 + closeMinute;

        const generateOptionStart = (openTime: string, closeTime: string): OptionType[] => {
          const [openHour, openMinute] = openTime.split(":").map(Number);
          const [closeHour, closeMinute] = closeTime.split(":").map(Number);
          const rawOpenMinutes = openHour * 60 + openMinute;
          const openMinutes = Math.ceil(rawOpenMinutes / 15) * 15;
          const closeMinutes = closeHour * 60 + closeMinute;
          const options: OptionType[] = [];
          const minDurationMinutes = enabledHourlyPrices.length > 0 ? Math.min(...enabledHourlyPrices) * 60 : 60;
          const lastPossibleStartTime = Math.max(openMinutes, closeMinutes - minDurationMinutes);

          for (let currentTime = openMinutes; currentTime <= lastPossibleStartTime; currentTime += 15) {
            const hour = Math.floor(currentTime / 60);
            const minute = currentTime % 60;
            const period = hour < 12 ? "A.M." : "P.M.";
            const adjustedHour = hour % 12 === 0 ? 12 : hour % 12;
            const displayMinute = minute < 10 ? `0${minute}` : minute;
            const label = `${adjustedHour < 10 ? "0" : ""}${adjustedHour}:${displayMinute} ${period}`;
            const value = `${adjustedHour < 10 ? "0" : ""}${adjustedHour}:${displayMinute} ${period}`;
            options.push({ value, label });
          }
          return options;
        };

        const generatedOptions = generateOptionStart(effectiveOpenTime, effectiveCloseTime);
        const isToday = selectedDate.toLocaleDateString() === new Date().toLocaleDateString();
        const currentTimeMinutes = new Date().getHours() * 60 + new Date().getMinutes();

        return generatedOptions.filter((option) => {
          const [time, period] = option.value.split(" ");
          const [hour, minute] = time.split(":").map(Number);
          const normalizedPeriod = period.replace(/\./g, '').toUpperCase();
          const optionHour24 = (normalizedPeriod === 'PM' && hour !== 12) ? hour + 12 :
            (normalizedPeriod === 'AM' && hour === 12) ? 0 :
              (normalizedPeriod === 'PM' && hour === 12) ? 12 : hour;
          const optionMinutes = optionHour24 * 60 + minute;

          if (isToday && optionMinutes < currentTimeMinutes) {
            return false;
          }
          return optionMinutes >= openMinutes && optionMinutes < closeMinutes;
        });
      };

      const availableOptions = filterTimesForDate(targetDate);
      if (availableOptions.length > 0 && filteredOptions.length === 0) {
        // Populate slots once when they become available and none are set yet
        setFilteredOptions(availableOptions);
      } else if (availableOptions.length === 0 && filteredOptions.length > 0) {
        // Target date is now known to be closed/inactive — clear stale slots
        setFilteredOptions([]);
        setStartTime(null);
        setEndTime(null);
      }
    }
  }, [storeSchedule, activeTab, timingOverrides]);

  useEffect(() => {
    if (startTime) {
      // Extract time and period, handling both '9:00 AM' and '09:00 A.M.' formats
      const timeParts = startTime.value.split(' ');
      const period = timeParts[1].replace(/\./g, ''); // Remove dots from period (A.M. -> AM)
      const [hours, minutes] = timeParts[0].split(':').map(Number);
      const currentStoreId = props?.details?.storeUuid || props?.storeDetails?.uuid;
      const isSpecificStore = isSpecificStoreId(currentStoreId);
      // Format the time with minutes
      const timeString = `${hours}:${minutes < 10 ? '0' : ''}${minutes} ${period}`;
      // Get enabled hourly times from prices (assuming 1, 2, 4 hours are mapped to their respective prices)
      const enabledHourlyTimes = enabledHourlyPrices.map(price => {
        if (price === 1) return 1;
        if (price === 2) return 2;
        if (price === 3) return 3;
        if (price === 4) return 4;
        return 0;
      }).filter(Boolean) as number[];

      let newEndTimeOptions = formatDynamicEndOptions(hours, timeString, storeSchedule, enabledHourlyTimes, calendarValue, props?.details?.storeUuid || props?.storeDetails?.uuid, timingOverrides);
      const selectedDate =
        dateRange[0] && dateRange[0].toISOString().split("T")[0];
      if (selectedDate) {
        const disabledTimes = getDisabledTimes1(selectedDate);
        if (disabledTimes.length > 0) {
          newEndTimeOptions = newEndTimeOptions.filter((option) => {
            const optionTime = extractTimeFromLabel(option.label);

            return (
              option.value !== "Full Day" && !disabledTimes.includes(optionTime)
            );
          });
        }
      }

      if (!props?.details?.dailyChecked) {
        const tempEndTimeOptions = newEndTimeOptions.filter(row => row.key !== 'fullDay');
        setEndTimeOptions(tempEndTimeOptions);
      } else {
        const tempEndTimeOptions = newEndTimeOptions.filter(row => row.key !== 'fullDay');
        if (isSpecificStore) {
          const startMinutes = minutes + (period === 'AM' ? hours * 60 : (hours % 12 + 12) * 60);
          // Get the schedule for the calendar value day to check close time
          const dayOfWeek = calendarValue.toLocaleDateString("en-US", { weekday: "long" });
          const scheduleForDay = storeSchedule.find(schedule => schedule.dayOfWeek === dayOfWeek);
          const calendarOverride = getOverrideForDate(calendarValue);
          const effectiveCloseTimeForSlots =
            (calendarOverride?.status === 'OPEN' || calendarOverride?.status === 'MODIFIED_HOURS') && calendarOverride.closeTime
              ? calendarOverride.closeTime
              : scheduleForDay?.closeTime;

          let showFullDay = false;

          // Check if Full Day should be shown for 9:00 AM
          if (hours === 9 && period === 'AM' && props?.productpricing?.oneDay !== null && props?.productpricing?.oneDay > 0) {
            // 9:00 AM to 5:00 PM = 8 hours = 1020 minutes
            tempEndTimeOptions.push({ value: "Full Day", label: "Full Day (4 P.M.)", key: 'fullDay' });
          }

          // Handle time slots based on the selected time
          if (effectiveCloseTimeForSlots) {
            const [closeHour, closeMinute] = effectiveCloseTimeForSlots.split(":").map(Number);
            const closeTimeInMinutes = closeHour * 60 + closeMinute;
            const eightPMInMinutes = 20 * 60; // 20:00 in 24-hour format
            const isStoreOpenLate = closeTimeInMinutes >= eightPMInMinutes;

            // Handle 1:00 PM slot
            if (hours === 1 && period === 'PM') {
              if (props?.productpricing?.eveningLong > 0 && isStoreOpenLate) {
                // Evening Long option (1:00 PM to 8:30 PM)
                const endTimeMinutes = (20.5 * 60).toString();
                tempEndTimeOptions.push({
                  value: endTimeMinutes,
                  label: "08:30 P.M. (Evening Long)",
                  key: 'sevenAndHalfHours'
                });
              }
            }

            // Handle 5:00 PM slot
            if (hours === 5 && period === 'PM') {
              if (props?.productpricing?.eveningShort > 0 && isStoreOpenLate) {
                // Evening Short option (5:00 PM to 8:30 PM)
                const endTimeMinutes = (20.5 * 60).toString();
                tempEndTimeOptions.push({
                  value: endTimeMinutes,
                  label: "08:30 P.M. (Evening Short)",
                  key: 'threeAndHalfHours'
                });
              } else {
                // If eveningShort is not available, don't show any end time options for 5 PM
                console.log('Evening Short not available or store closes too early');
              }
            }

            if (showFullDay) {
              tempEndTimeOptions.push({ value: "Full Day", label: "Full Day (4 P.M.)", key: 'fullDay' });
            }
          } else {
            // For regular stores, Full Day is standard option
            tempEndTimeOptions.push({ value: "Full Day", label: "Full Day (4 P.M.)", key: 'fullDay' });
          }
          setEndTimeOptions(tempEndTimeOptions);
        } else {
          setEndTimeOptions(tempEndTimeOptions);
        }
      }

      if (props?.details?.edit) {
        if (endTime) {
          setEndTime(endTime);
        }
      } else {
        setEndTime(null); // Reset the end time when start time changes
      }
    } else {
      setEndTimeOptions(optionEnd);
      setEndTime(null); // Reset the end time if no start time is selected
    }
  }, [startTime]);

  const extractTimeFromLabel = (label: string) => {
    const match = label.match(/(\d{2}:\d{2} [AP]\.M)/);
    return match ? match[0] : "";
  };

  const convertToIST = (timeStr: string) => {
    // Convert the time string from 12-hour format to a 24-hour format
    const [time, period] = timeStr.split(" ");
    const [hours, minutes] = time.split(":").map(Number);

    let utcHours = hours;

    // Adjust hours based on AM/PM
    if (period === "PM" && hours !== 12) {
      utcHours = hours + 12;
    } else if (period === "AM" && hours === 12) {
      utcHours = 0;
    }

    // Create a Date object for the time in UTC
    const utcDate = new Date(Date.UTC(1970, 0, 1, utcHours, minutes));

    // Convert to IST by adding the offset (5 hours 30 minutes)
    const istOffset = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
    const istDate = new Date(utcDate.getTime() + istOffset);

    // Format the IST date to 12-hour format with AM/PM
    let istHours = istDate.getUTCHours();
    const istMinutes = String(istDate.getUTCMinutes()).padStart(2, "0");

    const periodIST = istHours >= 12 ? "P.M" : "A.M";
    if (istHours > 12) {
      istHours -= 12;
    } else if (istHours === 0) {
      istHours = 12;
    }

    return `${String(istHours).padStart(2, "0")}:${istMinutes} ${periodIST}`;
  };


  const getDisabledTimes1 = (selectedDate: string): string[] => {
    return disableddHours
      .filter(
        (item: any) => item.date === moment(selectedDate).format("YYYY-MM-DD")
      )
      .map((u: any) => ({
        startHour: convertToIST(u.startTime),
        endHour: convertToIST(u.endTime),
      }));
  };


  const handleChangeStartTime = () => {
    setEndTime(null); // Set end time to null when start time changes
    setIsFocused(true); // Keep the focus state true to maintain the styling
  };

  useEffect(() => {
    if (props?.details?.edit) {
      if (
        isSameDate(
          props.details?.productBookingStartDate,
          props.details?.productBookingEndDate
        )
      ) {
        if (props.details?.productBookingStartDate) {
          setCalendarValue(new Date(props.details.productBookingStartDate));
          const formattedStartTime = formatTime(
            props.details.productBookingStartDate
          );
          setStartTime({
            label: formattedStartTime,
            value: formattedStartTime,
          });
          const duration = 4;
          setEndTime({
            label: `${formatTime(
              props.details.productBookingEndDate
            )} (${duration} hr${duration > 1 ? "s" : ""})`,
            value: `${duration} hr${duration > 1 ? "s" : ""}`,
          });
          setIsFocused(true);
        }
      } else {
        if (
          props.details?.productBookingStartDate &&
          props.details?.productBookingEndDate
        ) {
          dateRange[0] = new Date(props.details.productBookingStartDate);
          dateRange[1] = new Date(props.details.productBookingEndDate);
        }
      }
      setIsButtonDisabled(true);
    }
  }, [
    props.details?.edit,
    props.details?.productBookingEndDate,
    props.details?.productBookingStartDate,
  ]);

  function getDayName(dateString: string): string {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(date);
  }

  const checkIfStoreIsClosed = (date: Date) => {
    const override = getOverrideForDate(date);
    if (override) {
      if (override.status === 'CLOSED') return false;
      if (override.status === 'OPEN' || override.status === 'MODIFIED_HOURS') return true;
    }

    let dateString = date.toString();
    let dayName = getDayName(dateString);

    const daySchedule = storeSchedule.find((day: any) => day.dayOfWeek === dayName);
    return daySchedule?.isActive;
  };

  function updateClassNameBasedOnDateRange(
    date: Date,
    dateRange: (any)[],
    appendClassName: string
  ): string {
    if (!dateRange[0] || !dateRange[1]) {

      return appendClassName; // Return original className if dateRange is invalid
    }

    const [startDate, endDate] = dateRange.map((d: any) => new Date(d));
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {

      return appendClassName;
    }

    const isDateInRange = date >= startDate && date <= endDate;

    if (isDateInRange && !isRangeCleared) {
      return appendClassName
        .split(' ')
        .filter((className) => className !== "disabled-date")
        .join(' ');
    }

    return appendClassName; // Return unchanged if not in range
  }


  const tileClassName = ({ date, view }: any) => {
    let appendClassName = "";
    if (view === "month") {
      // Convert the input date to a UTC date object
      const currentDate = normalizeDate(date);
      if (isDateDisabled(date)) {
        let isStartDate = false;
        let isEndDate = false;


        for (let i = 0; i < disabledDates.length; i++) {
          const { startDate, endDate } = disabledDates[i];
          const start = normalizeDate(new Date(startDate));
          const end = normalizeDate(new Date(endDate));

          if (currentDate === start) {
            isStartDate = true;
          }
          if (currentDate === end) {
            isEndDate = true;
          }
        }

        if (isStartDate && isEndDate) {
          // Special case handling if a date is both start and end
          appendClassName = "start-end-date-disabled disabled-date";
        } else if (isStartDate) {
          appendClassName = "start-date-disabled disabled-date";
        } else if (isEndDate) {
          appendClassName = "end-date-disabled disabled-date";
        } else {
          appendClassName = "disabled-date";
        }
        if (activeTab === "daily") {
          appendClassName = updateClassNameBasedOnDateRange(date, dateRange, appendClassName);
        }
      }
      // check if store is opened or 
      let isDayActive = checkIfStoreIsClosed(date);
      if (storeSchedule && storeSchedule?.length > 0 && !isDayActive) {
        appendClassName = appendClassName ? appendClassName + " " + "Closed" : "Closed"
      }
    }
    return appendClassName;
  };

  const normalizeDate = (date: Date): string => {
    // Set time to midnight (start of the day) and return ISO string in YYYY-MM-DD format
    const utcDate = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    return utcDate.toISOString().split("T")[0]; // Extract the date part
  };

  const getOverrideForDate = (date: Date): StoreTimingOverride | undefined => {
    const isoDate = normalizeDate(date);
    return timingOverrides.find(o => {
      const start = normalizeDate(new Date(o.startDate));
      const end = normalizeDate(new Date(o.endDate));
      return isoDate >= start && isoDate <= end;
    });
  };

  const isDateDisabled = (date: Date): boolean => {
    // First check if the date is in the past
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date < today) {
      return true;
    }

    // Check timing overrides before falling back to store schedule
    const override = getOverrideForDate(date);
    if (override) {
      if (override.status === 'CLOSED') return true;
      // OPEN or MODIFIED_HOURS: store is active on this date despite schedule
      if (override.status === 'OPEN' || override.status === 'MODIFIED_HOURS') {
        const isoDate = normalizeDate(date);
        return disabledDates.some((range: any) => {
          const startDate = normalizeDate(new Date(range.startDate));
          const endDate = normalizeDate(new Date(range.endDate));
          return isoDate >= startDate && isoDate <= endDate;
        });
      }
    }

    // Check if store is closed on this day
    const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "long" });
    const scheduleForDay = storeSchedule.find(schedule =>
      schedule.dayOfWeek === dayOfWeek
    );

    // If store is closed on this day, disable it
    if (!scheduleForDay || !scheduleForDay.isActive) {
      return true;
    }

    // Check against disabled date ranges for all tabs
    const isoDate = normalizeDate(date);
    if (disabledDates.some((range: any) => {
      const startDate = normalizeDate(new Date(range.startDate));
      const endDate = normalizeDate(new Date(range.endDate));
      return isoDate >= startDate && isoDate <= endDate;
    })) {
      return true;
    }

    // Block date_ranges from the booking API for daily and monthly tabs only
    if (activeTab !== 'hourly' && hourlyBlockedDateRanges.length > 0 &&
      hourlyBlockedDateRanges.some(range =>
        isoDate >= range.start_date && isoDate <= range.end_date
      )) {
      return true;
    }

    return false;
  };
  const isRangeDisabled = (start: Date, end: Date) => {
    // Skip range validation for hourly tab
    if (activeTab === 'hourly') {
      return false;
    }

    if (disabledDates.some((range: any) => {
      const rangeStart = new Date(range.startDate);
      const rangeEnd = new Date(range.endDate);
      return start <= rangeEnd && end >= rangeStart;
    })) {
      return true;
    }

    // Also block ranges that contain a CLOSED override date
    const rangeStartIso = normalizeDate(start);
    const rangeEndIso = normalizeDate(end);
    return timingOverrides.some(override => {
      if (override.status !== 'CLOSED') return false;
      const overrideStart = override.startDate.split("T")[0];
      const overrideEnd = override.endDate.split("T")[0];
      return rangeStartIso <= overrideEnd && rangeEndIso >= overrideStart;
    });
  };
  const [showAlert, setShowAlert] = useState(false);
  const [isUserInteraction, setIsUserInteraction] = useState(false);

  const handleDayClick = (date: Date) => {
    if (isDailySelectedDateInRange()) {
      setIsRangeCleared(true);
    } else {
      setIsRangeCleared(false);
    }
  };

  const handleDateChange = (dates: any, type?: string, isUserAction: boolean = false) => {
    // Don't process date changes if modal is closing
    if (!props.show) {
      return;
    }

    let [start, end] = dates;
    if (start && !end) {
      setDateRange([start, null]);
      setIsButtonDisabled(true);
    } else if (start && end) {
      setIsRangeCleared(false);
      const isRangeValid = !isRangeDisabled(start, end);
      if (isRangeValid) {
        // setDateRange(dates);
        setDateRange([start, end]);
        // Enable the button
        if (type === 'one') {
          setIsStartDateDisabled(false);

          const filterTimesBasedOnDate = (
            selectedDate: Date,
          ): OptionType[] => {
            const dayOfWeek = selectedDate.toLocaleDateString("en-US", { weekday: "long" });

            // Find the schedule for the selected day
            const scheduleForDay = storeSchedule.find(schedule => schedule.dayOfWeek === dayOfWeek);
            const override = getOverrideForDate(selectedDate);
            if (override?.status === 'CLOSED') return [];
            const effectiveOpenTime = (override?.status === 'OPEN' || override?.status === 'MODIFIED_HOURS') && override.openTime ? override.openTime : scheduleForDay?.openTime;
            const effectiveCloseTime = (override?.status === 'OPEN' || override?.status === 'MODIFIED_HOURS') && override.closeTime ? override.closeTime : scheduleForDay?.closeTime;
            const isEffectivelyActive = (override?.status === 'OPEN' || override?.status === 'MODIFIED_HOURS') ? true : scheduleForDay?.isActive;

            if (!isEffectivelyActive || !effectiveOpenTime || !effectiveCloseTime) {
              // If the store is inactive or no schedule is found, return an empty array
              return [];
            }

            const currentStoreId = props?.details?.storeUuid || props?.storeDetails?.uuid;
            const isSpecificStore = isSpecificStoreId(currentStoreId);


            if (isSpecificStore) {
              // Handle specific store with only 9:00 AM, 1:00 PM, and conditionally 5:00 PM slots
              const isToday = selectedDate.toLocaleDateString() === new Date().toLocaleDateString();
              const currentTimeMinutes = new Date().getHours() * 60 + new Date().getMinutes();

              // For test different times 
              // const mockDate = new Date();
              // mockDate.setHours(9, 30, 0, 0); //ˆ change this to test different times

              // const currentTimeMinutes = mockDate.getHours() * 60 + mockDate.getMinutes();
              // Get the schedule for the selected day to check close time
              const scheduleForSelectedDay = storeSchedule.find(schedule => schedule.dayOfWeek === dayOfWeek);

              const options: OptionType[] = [];

              const specificStoreTimeSlots = getSpecificStoreTimeSlots(props?.productpricing, props?.details?.hourlyChecked);
              specificStoreTimeSlots.forEach(slot => {
                // Convert to 24-hour format for comparison
                let hour24 = slot.hour;
                if (slot.period === "P.M." && slot.hour !== 12) {
                  hour24 = slot.hour + 12;
                } else if (slot.period === "A.M." && slot.hour === 12) {
                  hour24 = 0;
                }

                const slotMinutes = hour24 * 60 + slot.minute;

                // Special handling for 5:00 PM slot - only show if store closes at 8:00 PM or later
                if (slot.hour === 5 && slot.period === "P.M.") {
                  if (effectiveCloseTime) {
                    const [closeHour, closeMinute] = effectiveCloseTime.split(":").map(Number);
                    const closeTimeInMinutes = closeHour * 60 + closeMinute;
                    const eightPMInMinutes = 20 * 60; // 20:00 in 24-hour format

                    // Skip this slot if store closes before 8:00 PM
                    if (closeTimeInMinutes < eightPMInMinutes) {
                      return; // Skip this iteration
                    }
                  } else {
                    return; // Skip if no close time found
                  }
                }

                const SLOT_CUTOFFS: Record<string, number> = {
                  "09:00 A.M.": 12 * 60,   // 9:00 AM slot visible until 12:00 PM
                  "01:00 P.M.": 16 * 60,   // 1:00 PM slot visible until 4:00 PM
                  "05:00 P.M.": 20 * 60,   // 5:00 PM slot visible until 8:00 PM
                };

                const slotKey = `${String(slot.hour).padStart(2, "0")}:${String(slot.minute).padStart(2, "0")} ${slot.period}`;
                const cutoff = SLOT_CUTOFFS[slotKey] ?? slotMinutes;

                if (!isToday || currentTimeMinutes < cutoff) {
                  const formattedHour = slot.hour < 10 ? `0${slot.hour}` : slot.hour;
                  const formattedMinute = slot.minute < 10 ? `0${slot.minute}` : slot.minute;
                  const label = `${formattedHour}:${formattedMinute} ${slot.period}`;
                  const value = `${formattedHour}:${formattedMinute} ${slot.period}`;

                  options.push({ value, label });
                }
              });

              return options;
            }

            // Extract open and close times in 24-hour format
            const [openHour24, openMinute] = effectiveOpenTime.split(":").map(Number);
            const [closeHour24, closeMinute] = effectiveCloseTime.split(":").map(Number);

            // Convert open and close times to minutes for easy comparison, rounding up to next 15-min mark
            const openMinutes = Math.ceil((openHour24 * 60 + openMinute) / 15) * 15;
            const closeMinutes = closeHour24 * 60 + closeMinute;

            // Function to generate options based on store open and close times
            const generateOptionStart = (openTime: string, closeTime: string): OptionType[] => {
              const [openHour, openMinute] = openTime.split(":").map(Number);
              const [closeHour, closeMinute] = closeTime.split(":").map(Number);

              const rawOpenMinutes = openHour * 60 + openMinute;
              const openMinutes = Math.ceil(rawOpenMinutes / 15) * 15;
              const closeMinutes = closeHour * 60 + closeMinute;

              const options: OptionType[] = [];

              // Last start time must leave enough room for the shortest enabled duration
              const minDurationMinutes = enabledHourlyPrices.length > 0 ? Math.min(...enabledHourlyPrices) * 60 : 60;
              const lastPossibleStartTime = Math.max(openMinutes, closeMinutes - minDurationMinutes);

              // Only generate times up to the last possible start time
              for (let currentTime = openMinutes; currentTime <= lastPossibleStartTime; currentTime += 15) {
                const hour = Math.floor(currentTime / 60);
                const minute = currentTime % 60;
                const period = hour < 12 ? "A.M." : "P.M.";
                const adjustedHour = hour % 12 === 0 ? 12 : hour % 12;

                // Format time as "HH:MM A.M./P.M." with proper minute display
                const displayMinute = minute < 10 ? `0${minute}` : minute;
                const label = `${adjustedHour < 10 ? "0" : ""}${adjustedHour}:${displayMinute} ${period}`;
                // Include minutes in the value for better parsing
                const value = `${adjustedHour < 10 ? "0" : ""}${adjustedHour}:${displayMinute} ${period}`;
                options.push({ value, label });
              }

              return options;
            };

            // Generate optionStart dynamically based on store schedule
            const optionStart = generateOptionStart(effectiveOpenTime, effectiveCloseTime);

            // Check if the selected date is today
            const isToday = selectedDate.toLocaleDateString() === new Date().toLocaleDateString();

            // Get the current system time in minutes
            const currentTimeMinutes = new Date().getHours() * 60 + new Date().getMinutes();

            // Filter the optionStart array based on store timings, the selected date, and current system time
            const filteredOptions = optionStart.filter((option) => {
              const [time, period] = option.value.split(" ");
              const [hour, minute] = time.split(":").map(Number);

              // Convert 12-hour format to 24-hour format for comparison
              // Handle both "P.M." and "P.M" formats by normalizing the period
              const normalizedPeriod = period.replace(/\./g, '').toUpperCase();
              const optionHour24 = (normalizedPeriod === 'PM' && hour !== 12) ? hour + 12 :
                (normalizedPeriod === 'AM' && hour === 12) ? 0 :
                  (normalizedPeriod === 'PM' && hour === 12) ? 12 : hour;
              const optionMinutes = optionHour24 * 60 + minute;

              // If the selected date is today, exclude times that are in the past
              if (isToday && optionMinutes < currentTimeMinutes) {
                return false;
              }

              // Ensure the option is within the store's open and (close - 1 hour) times
              return optionMinutes >= openMinutes && optionMinutes < closeMinutes;
            });

            return filteredOptions;
          };


          const availableOptions = filterTimesBasedOnDate(start);

          setFilteredOptions(availableOptions);
          // }

          if (
            !startTime?.value &&
            !endTime?.value &&
            !!fullDayValue &&
            !isSelectedDateDisabled
          ) {
            setIsButtonDisabled(true);
          } else {
            !endTime?.value
              ? setIsButtonDisabled(true)
              : setIsButtonDisabled(false);
          }
        } else if (type === 'monthly') {
          !selectedMonth
            ? setIsButtonDisabled(true)
            : setIsButtonDisabled(false);
        } else if (type === 'daily') {
          !selectedDay
            ? setIsButtonDisabled(true)
            : setIsButtonDisabled(false);
        } else {
          calculatePrice(dates);
          setSelectedMonth(null);
          setIsButtonDisabled(false);
        }
      } else {
        setIsButtonDisabled(true); // Disable the button
        // Only show alert if this is a user-initiated action, not a variant/data change
        if (isUserAction) {
          setShowAlert(true); // Show the alert
        }
      }
    }
  };

  // Function to handle model dismissal
  const handleAlertDismiss = () => {
    // After user dismisses the alert, check the current date range
    const [start, end] = dateRange;

    // Check if the current date range is valid and not disabled
    if (start && end && !isRangeDisabled(start, end)) {
      setIsButtonDisabled(false); // Enable the button
    }

    setShowAlert(false); // Hide the alert
  };

  const changesEndTime = () => {
    if (startTime && endTime) {
      setIsButtonDisabled(!isSelectedDateDisabled);
      if (!dateRange[0] || !dateRange[1]) {
        return; // Handle if dateRange[0] or dateRange[1] is not defined or null
      }
      const timeParts = startTime.value.split(" ");

      // Extract time and period from endTime.label, ignoring the duration part in parentheses
      // endTime.label format: "03:00 P.M. (2 hrs)" -> extract "03:00" and "P.M."
      const labelBeforeParens = endTime.label.split("(")[0].trim(); // "03:00 P.M."
      const timePartsEnd = labelBeforeParens.split(" "); // ['03:00', 'P.M.']

      // Parse start and end dates
      const startDate = new Date(dateRange[0]);
      const endDate = new Date(dateRange[1]);

      const startHour24 = convertTo24HourFormat(timeParts[0], timeParts[1]);
      const endHour24 = convertTo24HourFormat(timePartsEnd[0], timePartsEnd[1]);

      // Convert decimal hours to hours and minutes
      const startHours = Math.floor(startHour24);
      const startMinutes = Math.round((startHour24 - startHours) * 60);
      const endHours = Math.floor(endHour24);
      const endMinutes = Math.round((endHour24 - endHours) * 60);

      // Set hours and minutes to the dates
      startDate.setHours(startHours, startMinutes, 0, 0);
      endDate.setHours(endHours, endMinutes, 0, 0);

      dateRange[0] = startDate;
      dateRange[1] = endDate;
    }
  };

  const convertTo24HourFormat = (time: string, period: string): number => {
    // Split into hours and minutes
    const [hoursStr, minutesStr = '00'] = time.split(":");
    let hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10) / 60; // Convert minutes to fraction of an hour

    // Normalize period by removing dots (P.M. -> PM, A.M. -> AM)
    const normalizedPeriod = period.replace(/\./g, '').toUpperCase();

    // Convert to 24-hour format
    if (normalizedPeriod === "PM" && hours !== 12) {
      hours += 12;
    } else if (normalizedPeriod === "AM" && hours === 12) {
      hours = 0;
    }

    // Return total hours including minutes as a decimal
    return hours + minutes;
  };

  const setProductEndDate = (dates: any) => {
    const [start, end] = dates;

    const returnBookingDate = getReturnDate(end, inactiveDays);
    if (returnBookingDate) {
      setReturnEndDate(returnBookingDate);
    }


    return returnBookingDate;
  }

  const calculatePrice = async (dates: any, bookingEndDateForCustomerQuote?: string) => {
    const [start, end] = dates;

    const days = countDays(start, end);
    const id = props?.productuuid ?? props?.details?.productUuid;

    let request: any;
    if (props?.details?.edit) {
      const productList = props?.details?.productDetails.map((item: any) => ({
        productUuid: item.productUuid,
        retailerUuid: item?.retailerUuid,
        storeUuid: item?.storeUuid,
        rentalDuration: days, // rental duration,
        quantity: item?.productQuantity ? item?.productQuantity : 1,
        rentalType: "daily",
        bookingDate: {
          bookingStartDate: getLocalDate(start).toISOString(),
          bookingEndDate: getLocalDate(end).toISOString(),
        },
        productVariantUuid: item?.productVariantUuid,
        option1: item?.option1,
        option2: item?.option2,
        option3: item?.option3,
      }));
      request = {
        products: productList,
      };
    } else {
      request = {
        products: [
          {
            baseProductUuidForAddOn: props?.productuuid,
            productUuid: id,
            retailerUuid: props?.details?.retailerUuid,
            storeUuid: props?.details?.storeUuid,
            rentalDuration: days, // rental duration,
            quantity: props.selectedQuantity || 1,
            rentalType: "daily",
            bookingDate: {
              bookingStartDate: getLocalDate(start)?.toISOString(),
              bookingEndDate: getLocalDate(end).toISOString(),
            },
            productVariantUuid: props?.productVariantUuid,
            ...quoteId && { previousQuoteUuid: quoteId },
            ...(props?.variantOptions || {}) // Include variant options if available
          },
        ],
      };
    }
    setIsLoading(true);

    await productDetailsClient
      .getQuotesCharges(request)
      .then(async (data: any) => {
        setRentPrice(data.orderValue);
        setIsLoading(false);
        setIsProductAvailable(data?.productAvailibility);
        setIsProductEnabled(data?.updateQuoteProduct);
        setRecommendedProductsCount(data?.addOnProductCount ?? 0);
        if (!data.updateQuoteProduct || !data.productAvailibility) {
          setStartTime(null);
          setEndTime(null);
          if (data?.productRates?.length > 1) {
            const filteredProductNames = data?.productRates
              .filter((product: any) => !product?.updateQuoteProduct) // Filter products where updateQuoteProduct is false
              .map((product: any) => product?.productName);
            toast.success(
              `The following items are not available for your selected dates: ${filteredProductNames.join(
                ", "
              )}. Remove this product from your basket to select these dates.`
            );
          } else {
            if (!data?.productAvailibility) {
              if ((data.productRates[0]?.monthlyChecked || data.productRates[0]?.monthlyRecurringChecked) && days > 28) {
                toast.success("For Rentals longer then 28 days please select the Monthly tab.");
              } else if ((data.productRates[0]?.dailyChecked || data?.productRates[0]?.weeklyChecked) && days > 28) {
                toast.success("Maximum Rental duration of 28 days for this item.");
              } else {
                toast.success("This item is not available on selected dates.");
                // if (data?.productRates[0]?.error)
                //   toast.success(data?.productRates[0]?.error);
              }
            } else if (
              data?.productRates[0]?.dailyChecked &&
              !data?.productRates[0]?.weeklyChecked
            ) {
              toast.success(
                "The maximum Rental duration for this item is 6 days, please re-select your dates."
              );
            } else if (
              !data?.productRates[0]?.dailyChecked &&
              data?.productRates[0]?.weeklyChecked
            ) {
              toast.success(
                "The minimal Rental duration for this item is 7 days, please re-select your dates."
              );
            } else {
              toast.error("Something went wrong.");
            }
          }
        }

        if (props?.details?.edit) {
          if (data.productAvailibility) {
            const productData = data.productRates.map((proData: any) => ({
              productRentalTerm: proData.rentalTerm,
              productRate: proData.productRate,
              productDepositAmount: proData?.productDepositAmount,
              productQuantity: proData?.quantity ? proData?.quantity : 1,
              productRentalPrice: proData?.productRentalValue,
              productRetailValue: proData?.productRetailValue,
              productUuid: proData?.productUuid,
              productName: "",
              bookingDate: request?.products[0]?.bookingDate,
              productVariantUuid: proData?.productVariantUuid,
              option1: proData?.option1,
              option2: proData?.option2,
              option3: proData?.option3,
            }));
            const mergedArray = productData.map((item1: any) => {
              const match = props?.details?.productDetails?.find(
                (item2: any) => item2.productUuid === item1.productUuid && item2.productVariantUuid === item1.productVariantUuid
              );
              let dateRangeUpdated = checkAndGetNextActiveDay();
              return match
                ? {
                  ...item1,
                  productName: match?.productName,
                  bookingDate: {
                    bookingStartDate: getLocalDate(
                      dateRangeUpdated[0]
                    ).toISOString(),
                    bookingEndDate: getLocalDate(dateRangeUpdated[1]).toISOString(),
                  },
                  productVariantUuid: match?.productVariantUuid,
                  productRetailValue: match?.productRetailValue,
                  option1: match?.option1,
                  option2: match?.option2,
                  option3: match?.option3,
                }
                : item1;
            });

            const requestData = {
              products: mergedArray,
              quoteTotal: data?.orderValue,
              depositAmount: data?.depositCharge,
              serviceCharge: data?.serviceCharge,
              deliveryCharge: data?.deliveryCharge,
              // deliveryCharge: data?.instoreCollectionCharge,
              instoreCollectionCharge: data?.instoreCollectionCharge,
              storeUuid: props?.details?.storeUuid,
              rentalType: "daily",
              retailerUuid: props?.details?.retailerUuid,
              rentalDuration: days, // rental duration, 
              ...(props?.variantOptions || {}) // Include variant options if available
            };

            setEditProductData(requestData);
            setQuateCharges(data);
          } else {
            toast.success("Product is not available on selected date.");
          }
        } else {
          const productPrice = data.productRates.filter(
            (data: any) => props?.details?.uuid == data.productUuid
          )[0];

          setProductRate(productPrice.productRate);
          setQuateCharges(data);
        }

        setIsButtonDisabled(false);
      })
      .catch((error) => {
        toast.error(error?.message);
        // setToastMessage(error.message);
        // setShowToast(true);
        // setToastType("danger");
      });
  };

  const checkAndGetNextActiveDay = () => {
    const isDayActive = (date: any) => {
      const dayOfWeek = format(date, "EEEE"); // Get the day of the week (e.g., "Monday")
      const schedule = storeSchedule.find((item) => item.dayOfWeek === dayOfWeek);
      return schedule?.isActive ?? false;
    };

    // Function to find the next active day
    const getNextActiveDay = (date: any) => {
      let nextDate = addDays(date, 1);
      while (!isDayActive(nextDate)) {
        nextDate = addDays(nextDate, 1);
      }
      return nextDate;
    };
    let nextActiveDate = null;
    // If endDate is present, check and update if needed
    if (dateRange[1]) {
      const endDate = dateRange[1];
      if (!isDayActive(endDate)) {
        nextActiveDate = getNextActiveDay(endDate);
      } else {
        nextActiveDate = dateRange[1]
      }
    }
    return [dateRange[0], nextActiveDate ? new Date(nextActiveDate.toISOString()) : null];
  }
  const submit = async () => {
    let dateRangeUpdated = checkAndGetNextActiveDay();

    let hourSelectedValue = 1; // Default to 1 hour
    const countedDays = countDays(dateRange[0], dateRange[1]);

    // Use the key field to determine duration for special cases
    if (endTime?.key === 'threeAndHalfHours') {
      hourSelectedValue = 3.5;
    } else if (endTime?.key === 'sevenAndHalfHours') {
      hourSelectedValue = 7.5;
    } else {
      // Extract hours from the label which contains the duration in parentheses
      const durationMatch = endTime?.label?.match(/\((\d+(?:\.\d+)?)\s*hrs?\)/i);
      if (durationMatch) {
        const hours = parseFloat(durationMatch[1]);
        if ([1, 2, 3, 4].includes(hours)) {
          hourSelectedValue = hours;
        }
      }
      // Fallback to check value if label match fails
      else if (endTime?.value) {
        const match = endTime.value.match(/(\d+(?:\.\d+)?)\s*hr?s/i);
        const hours = match ? parseFloat(match[1]) : 1;
        if ([1, 2, 3, 4].includes(hours)) {
          hourSelectedValue = hours;
        }
      }
      if (endTime?.value === "Full Day") {
        hourSelectedValue = 1;
      }
    }

    if (props.details?.edit) {
      await productDetailsClient
        .createQuote(editProductData)
        .then(async (res: any) => {
          if (props?.details?.discountCode) {
            await productDetailsClient.applyPromoCode({
              quoteUuid: res?.quote?.uuid,
              discountCode: props?.details?.discountCode,
            });
          }
          setQuoteCookies(res.quote.uuid);
          const bookingDate = JSON.stringify({
            startDate: dateRangeUpdated[0],
            endDate: dateRangeUpdated[1],
            rentPrice: rentPrice,
          });
          localStorage.setItem("bookingDate", bookingDate);
          setQuoteCookies(res.quote.uuid);
          await productDetailsClient
            .deleteQuote({
              quoteUuid: quoteId,
            })
            .then((response: any) => {
              // Reset all selected dates and times after successful submission
              setActiveTab('');
              setDateRange([null, null]);
              setSelectedDay(null);
              setSelectedMonth(null);
              setStartTime(null);
              setEndTime(null);
              setReturnEndDate('');
              setCalendarValue(new Date());
              setRentPrice(null);
              setProductRate(null);
              setIsButtonDisabled(false);
              setShowAlert(false);

              onHide();
            })
            .catch((err: any) => {

            });
          // navigate("/cart");
        })
        .catch((error: any) => {
          toast.error(error?.message);
        });
    } else {
      let selectedDateFlag: any = calculateDurationFlag(
        dateRangeUpdated[0],
        dateRangeUpdated[1]
      );
      if (activeTab === rentalType.daily) {
        selectedDateFlag = rentalType.daily;
      }
      let rentalTeams = selectedDateFlag === "hourly" ? hourSelectedValue : countedDays;
      if (selectedMonth?.value) {
        selectedDateFlag = selectedMonth.label === monthOptionLabel.FULLly_FLEXIBLE ? 'monthly-recurring' : 'monthly';
        rentalTeams = selectedMonth.label === monthOptionLabel.FULLly_FLEXIBLE ? 12 : selectedMonth.value;
      }

      const value = {
        products: [
          {
            productName: props.details.productName,
            productUuid: props.details.uuid,
            productRentalPrice: rentPrice,
            productRetailValue: props?.details?.productRetailValue,
            productQuantity: props.selectedQuantity || 1,
            productRate: productRate,
            productRentalTerm: rentalTeams,
            bookingDate: {
              bookingStartDate: getLocalDate(dateRangeUpdated[0])?.toISOString(),
              bookingEndDate: returnEndDate ? getLocalDate(new Date(returnEndDate))?.toISOString() : getLocalDate(dateRangeUpdated[1])?.toISOString(),
            },
            productDepositAmount: quateCharges?.productDepositAmount,
            productVariantUuid: props?.productVariantUuid,
            ...(props?.variantOptions || {}) // Include variant options if available
          },
        ],
        rentalType: selectedDateFlag,
        rentalDuration: rentalTeams,
        quoteTotal: quateCharges?.orderValue,
        depositAmount: quateCharges?.depositCharge,
        serviceCharge: quateCharges?.serviceCharge,
        deliveryCharge: quateCharges?.deliveryCharge,
        instoreCollectionCharge: quateCharges?.instoreCollectionCharge,
        storeUuid: props.details.storeUuid,
        retailerUuid: props.details.retailerUuid,
        ...(quoteId ? { quoteUuid: quoteId } : {}),
        ...(customerUuid ? { customerUuid: customerUuid } : {}),
        ...(props?.variantOptions || {}) // Include variant options if available
      };

      if (!props?.details?.edit && recommendedProductsCount > 0) {
        value && setQuoteProductData && setQuoteProductData({
          value: value,
          bookingStartDate: getLocalDate(dateRangeUpdated[0])?.toISOString(),
          bookingEndDate: returnEndDate ? getLocalDate(new Date(returnEndDate))?.toISOString() : getLocalDate(dateRangeUpdated[1])?.toISOString(),
          storeUuid: props.details.storeUuid,
          ...(quoteId ? { quoteUuid: quoteId } : {}),
          rentalType: selectedDateFlag,
          startDate: dateRangeUpdated[0],
          endDate: dateRangeUpdated[1],
          rentPrice: rentPrice,
        });
        onHide();

        // Reset all selected dates and times after successful submission
        setActiveTab('');
        setDateRange([null, null]);
        setSelectedDay(null);
        setSelectedMonth(null);
        setStartTime(null);
        setEndTime(null);
        setReturnEndDate('');
        setCalendarValue(new Date());
        setRentPrice(null);
        setProductRate(null);
        setIsButtonDisabled(false);
        setShowAlert(false);

        if (openAddOnModal) {
          openAddOnModal();
        }
      } else {
        productDetailsClient
          .createQuote(value)
          .then((res: any) => {
            setQuoteCookies(res.quote.uuid);
            const bookingDate = JSON.stringify({
              startDate: dateRangeUpdated[0],
              endDate: dateRangeUpdated[1],
              rentPrice: rentPrice,
            });
            localStorage.setItem("bookingDate", bookingDate);

            // Reset all selected dates and times after successful submission
            setActiveTab('');
            setDateRange([null, null]);
            setSelectedDay(null);
            setSelectedMonth(null);
            setStartTime(null);
            setEndTime(null);
            setReturnEndDate('');
            setCalendarValue(new Date());
            setRentPrice(null);
            setProductRate(null);
            setIsButtonDisabled(false);
            setShowAlert(false);

            onHide();
            navigate("/cart");
          })
          .catch((error: any) => {
            toast.error(error?.message);
          });
      }
    }
  };


  const [calendarValue, setCalendarValue] = useState<Date>(new Date());
  const { t } = useTranslation();
  const maxDate = new Date();
  maxDate.setMonth(maxDate.getMonth() + 12);

  const getDefaultActiveKey = () => {
    let activeTab = "";
    const productDetails = props.details?.edit ? props.details.productDetailsByUUID : props.details;

    // Check hourly: if checked and not disabled
    if ((props.details?.hourlyChecked || productDetails?.hourlyChecked) && !isDayOrLessDisabled) {
      activeTab = "hourly";
    }
    // Check daily/weekly: if either checked and not disabled (weekly options appear in daily tab)
    else if ((props.details?.dailyChecked || props.details?.weeklyChecked || productDetails?.dailyChecked || productDetails?.weeklyChecked) && !isMultipleDaysDisabled) {
      activeTab = "daily";
    }
    // Check monthly: if checked and not disabled
    else if ((props.details?.monthlyChecked || productDetails?.monthlyRecurringChecked) && !isMonthlyDisabled) {
      activeTab = "monthly";
    }
    // Fallback to first available tab
    else if (!isDayOrLessDisabled) {
      activeTab = "hourly";
    }
    else if (!isMultipleDaysDisabled) {
      activeTab = "daily";
    }
    else if (!isMonthlyDisabled) {
      activeTab = "monthly";
    }
    else {
      activeTab = "hourly"; // Last resort
    }
    return activeTab;
  };

  useEffect(() => {
    if (!activeTab) {
      let activeTabValue = "";
      const productDetails = props?.details?.edit ? props?.details.productDetailsByUUID : props.details;

      // Check hourly: if checked and not disabled
      if ((props.details?.hourlyChecked || productDetails?.hourlyChecked) && !isDayOrLessDisabled) {
        activeTabValue = "hourly";
      }
      // Check daily/weekly: if either checked and not disabled (weekly options appear in daily tab)
      else if ((props.details?.dailyChecked || props.details?.weeklyChecked || productDetails?.dailyChecked || productDetails?.weeklyChecked) && !isMultipleDaysDisabled) {
        activeTabValue = "daily";
        // Auto-select today's date when daily/weekly tab is auto-selected
        changeSelectedDay(new Date());
      }
      // Check monthly: if checked and not disabled
      else if ((props.details?.monthlyChecked || productDetails?.monthlyRecurringChecked) && !isMonthlyDisabled) {
        activeTabValue = "monthly";
        // Auto-select today's date when monthly tab is auto-selected
        const today = new Date();
        handleDateChange([today, today], "monthly");
        setCalendarValue(today);
        setDateRange([today, today]);
      }
      // Fallback to first available tab
      else if (!isDayOrLessDisabled) {
        activeTabValue = "hourly";
      }
      else if (!isMultipleDaysDisabled) {
        activeTabValue = "daily";
        // Auto-select today's date
        changeSelectedDay(new Date());
      }
      else if (!isMonthlyDisabled) {
        activeTabValue = "monthly";
        // Auto-select today's date
        const today = new Date();
        handleDateChange([today, today], "monthly");
        setCalendarValue(today);
        setDateRange([today, today]);
      }

      setActiveTab(activeTabValue);
    }
  }, [props, isDayOrLessDisabled, isMultipleDaysDisabled, isMonthlyDisabled])

  // Ensure dayOptions (including both daily and weekly options) is populated when on daily tab
  useEffect(() => {
    if (activeTab === 'daily' && dayOptionsArray.length > 0) {
      setDayOptions(dayOptionsArray); // dayOptionsArray contains both daily and weekly options
    }
  }, [activeTab, dayOptionsArray])

  useEffect(() => {
    if (!dateRange) {
      return;
    }

    if (activeTab === 'monthly') {
      if (dateRange[0] && selectedMonth) {
        const calculatedEndDate = calculateMonthlyEndDate(dateRange[0], selectedMonth?.value);
        dateRange[1] = calculatedEndDate;
        getMonthlyCharges()

      }
    } else if (activeTab === 'daily') {
      if (dateRange[0] && selectedDay) {
        const calculatedEndDate = calculateDailyEndDate(dateRange[0], selectedDay?.value);
        dateRange[1] = calculatedEndDate;

        // const isStoreOpenOnEndDate = storeSchedule.find(schedule => schedule.dayOfWeek === getDayName(calculatedEndDate.toString()))?.isActive;
        // if (isStoreOpenOnEndDate) {
        const bookingEndDateForCustomerQuote = setProductEndDate(dateRange);
        calculatePrice(dateRange, bookingEndDateForCustomerQuote);
        // changeSelectedDay(new Date());
        // } 
        // else {
        //   setDateRange([dateRange[0], dateRange[0]]);
        //   setSelectedDay(null);        
        //   setRentPrice(null);
        //   toast.error('End date cannot be set on the day when store is closed');
        // }      
      }
    }
  }, [selectedMonth, selectedDay, dateRange])

  const calculateDailyEndDate = (startDate: Date, duration: string) => {
    const newDate = new Date(startDate);
    newDate.setDate(newDate.getDate() + (parseInt(duration)) - 1);
    return newDate;
  };

  const calculateMonthlyEndDate = (startDate: Date, duration: string) => {
    const newDate = new Date(startDate);
    switch (duration) {
      case '1':
        newDate.setMonth(newDate.getMonth() + 1); // Adds 1 month to the start date
        break;
      case '2':
        newDate.setMonth(newDate.getMonth() + 2); // Adds 2 months
        break;
      case '3':
        newDate.setMonth(newDate.getMonth() + 3); // Adds 3 months
        break;
      case '12':
        newDate.setFullYear(newDate.getFullYear() + 1); // Adds 1 year
        break;
      default:
        break;
    }
    newDate.setHours(23, 59, 59, 999);
    return newDate;
  };

  const getMonthlyCharges = async () => {
    let dateRangeUpdated = checkAndGetNextActiveDay();
    const rentalType = selectedMonth.label === monthOptionLabel.FULLly_FLEXIBLE ? "monthly-recurring" : "monthly";
    const id = props?.productuuid ?? props?.details?.productUuid;
    let request: any;
    if (props?.details?.edit) {
      const products = props?.details?.productDetails.map((item: any) => ({
        productUuid: item.productUuid,
        retailerUuid: item?.retailerUuid,
        storeUuid: item?.storeUuid,
        rentalDuration: selectedMonth?.value, // rental duration,
        quantity: item?.productQuantity ? item?.productQuantity : 1,
        rentalType: rentalType,
        bookingDate: {
          bookingStartDate: getLocalDate(dateRangeUpdated[0]),
          bookingEndDate: getLocalDate(dateRangeUpdated[1]),
        },
        productVariantUuid: item?.productVariantUuid,
        option1: item?.option1,
        option2: item?.option2,
        option3: item?.option3,
      }));
      request = { products: products };
    } else {
      request = {
        products: [
          {
            baseProductUuidForAddOn: props?.productuuid,
            productUuid: id,
            retailerUuid: props?.details?.retailerUuid,
            storeUuid: props?.details?.storeUuid,
            rentalDuration: selectedMonth?.value, // rental duration,
            quantity: 1,
            rentalType: rentalType,
            bookingDate: {
              bookingStartDate: getLocalDate(dateRangeUpdated[0])?.toISOString(),
              bookingEndDate: getLocalDate(dateRangeUpdated[1])?.toISOString(),
            },
            productVariantUuid: props?.productVariantUuid,
            ...quoteId && { previousQuoteUuid: quoteId },
            ...(props?.variantOptions || {}) // Include variant options if available
          },
        ],
      };
    }
    setIsLoading(true);

    await productDetailsClient
      .getQuotesCharges(request)
      .then(async (data: any) => {
        setRentPrice(data.orderValue);
        setIsLoading(false);
        setIsProductAvailable(data?.productAvailibility);
        setIsProductEnabled(data?.updateQuoteProduct);
        setRecommendedProductsCount(data?.addOnProductCount ?? 0);
        if (!data.updateQuoteProduct || !data.productAvailibility) {
          setStartTime(null);
          setEndTime(null);
          if (data?.productRates?.length > 1) {
            const filteredProductNames = data?.productRates
              .filter((product: any) => !product?.updateQuoteProduct) // Filter products where updateQuoteProduct is false
              .map((product: any) => product?.productName);
            toast.success(
              `The following items are not available for your selected dates: ${filteredProductNames.join(
                ", "
              )}. Remove this product from your basket to select these dates.`
            );
          } else {
            if (!data.productAvailibility) {
              toast.success("This item is not available on selected dates.");
            } else if (
              data.productRates[0]?.dailyChecked &&
              !data.productRates[0]?.weeklyChecked
            ) {
              toast.success(
                "The maximum Rental duration for this item is 6 days, please re-select your dates."
              );
            } else if (
              !data.productRates[0]?.dailyChecked &&
              data.productRates[0]?.weeklyChecked
            ) {
              toast.success(
                "The minimal Rental duration for this item is 7 days, please re-select your dates."
              );
            } else {
              toast.error("Something went wrong.");
            }
          }
        }
        if (props?.details?.edit) {
          if (data.productAvailibility) {
            const productData = data.productRates.map((proData: any) => ({
              productRentalTerm: proData.rentalTerm,
              productRate: proData.productRate,
              productDepositAmount: proData?.productDepositAmount,
              productQuantity: proData?.quantity ? proData?.quantity : 1,
              productRentalPrice: proData?.productRentalValue,
              productRetailValue: proData?.productRetailValue,
              productUuid: proData?.productUuid,
              productName: "",
              bookingDate: request?.products[0]?.bookingDate,
              productVariantUuid: props?.productVariantUuid,
              ...(props?.variantOptions || {}) // Include variant options if available
            }));

            const mergedArray = productData.map((item1: any) => {
              const match = props?.details?.productDetails?.find(
                (item2: any) => item2.productUuid === item1.productUuid && item2.productVariantUuid === item1.productVariantUuid
              );
              let dateRangeUpdated = checkAndGetNextActiveDay();
              return match
                ? {
                  ...item1,
                  productName: match?.productName,
                  bookingDate: {
                    bookingStartDate: getLocalDate(
                      dateRangeUpdated[0]
                    ).toISOString(),
                    bookingEndDate: getLocalDate(dateRangeUpdated[1]).toISOString(),
                  },
                  productVariantUuid: match?.productVariantUuid,
                  productRetailValue: match?.productRetailValue,
                  option1: match?.option1,
                  option2: match?.option2,
                  option3: match?.option3,
                }
                : item1;
            });

            const requestData = {
              products: mergedArray,
              quoteTotal: data?.orderValue,
              depositAmount: data?.depositCharge,
              serviceCharge: data?.serviceCharge,
              // deliveryCharge: data?.instoreCollectionCharge,
              deliveryCharge: data?.deliveryCharge,
              instoreCollectionCharge: data?.instoreCollectionCharge,
              storeUuid: props?.details?.storeUuid,
              rentalType: rentalType,
              retailerUuid: props?.details?.retailerUuid,
              rentalDuration: selectedMonth?.value, // rental duration, 
              ...(props?.variantOptions || {}) // Include variant options if available
            };

            const productPrice = requestData.products.filter(
              (data: any) => props?.details?.productUuid[0] == data.productUuid
            )[0];
            setProductRentalValue(productPrice.productRentalPrice);
            setProductRetailValue(productPrice.productRetailValue);
            setEditProductData(requestData);
            setQuateCharges(data);
          } else {
            toast.success("Product is not available on selected date.");
          }
        } else {
          const productPrice = data.productRates.filter(
            (data: any) => props?.details?.uuid == data.productUuid
          )[0];

          setProductRate(productPrice.productRate);
          setProductRentalValue(productPrice.productRentalValue);
          setProductRetailValue(productPrice.productRetailValue);
          setQuateCharges(data);
        }

        setIsButtonDisabled(false);
      })
      .catch((error) => {
        toast.error(error?.message);
      });
  }

  // Custom Option component to display 'Cancel anytime' under 'Flexible monthly'
  const CustomOption = (props: any) => {
    return (
      <components.Option {...props}>
        <div>
          {props.children}
          {props.data.value === '12' && (
            <small style={{ color: '#333', display: 'block', marginTop: '4px' }}>
              Cancel anytime.
            </small>
          )}
        </div>
      </components.Option>
    );
  };

  const changeSelectedDay = (value: any) => {
    if (isDateDisabled(value)) {
      setDateRange([null, null]);
      setSelectedDay(null);
      setRentPrice(null);
      setDayOptions(dayOptionsArray);
      return;
    }
    handleDateChange([value, value], "daily", true);
    setDateRange([value, value]);
    setSelectedDay(null);
    setRentPrice(null);

    const selectedDate = value as Date;

    // const enabledDays = dayOptionsArray.filter((day) => {

    //   const tempDate = new Date(selectedDate); 
    //   tempDate.setDate(tempDate.getDate() + (parseInt(day.value) - 1));

    //   const dayName = getDayName(tempDate.toString());

    //   const isStoreOpenForTheDay = storeSchedule.find(schedule => schedule.dayOfWeek === dayName)?.isActive;          

    //   return isStoreOpenForTheDay;
    // });

    setDayOptions(dayOptionsArray);
  };

  const availableStartTimeOptions = filteredOptions.filter(opt => {
    const time24 = optionTimeTo24h(opt.value);
    if (blockedHourlySlots.includes(time24)) return false;
    if (blockedHourlySlots.length > 0) {
      const [sh, sm] = time24.split(':').map(Number);
      const startMins = sh * 60 + sm;
      const minDuration = enabledHourlyPrices.length > 0 ? Math.min(...enabledHourlyPrices) * 60 : 60;
      const minEndMins = startMins + minDuration;
      return !blockedHourlySlots.some(slot => {
        const [bh, bm] = slot.split(':').map(Number);
        const slotMins = bh * 60 + bm;
        return slotMins > startMins && slotMins <= minEndMins;
      });
    }
    return true;
  });

  const noTimeSlotsAvailable = activeTab === 'hourly' && !!calendarValue && storeSchedule.length > 0 && availableStartTimeOptions.length === 0;
  const isSelectedDateToday = calendarValue?.toLocaleDateString() === new Date().toLocaleDateString();

  return (
    <div>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size={modalSize}
        onHide={() => {
          // Reset all selected dates and times
          setActiveTab('');
          setDateRange([null, null]);
          setSelectedDay(null);
          setSelectedMonth(null);
          setStartTime(null);
          setEndTime(null);
          setReturnEndDate('');
          setCalendarValue(new Date());
          setRentPrice(null);
          setProductRate(null);
          setIsButtonDisabled(false);
          setShowAlert(false);
          onHide();
        }
        }
        className={`calendar-modal`}
      >
        <div className={`${isMenuOpen ? "menu-mobile-open" : ""}`}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {props.details?.isAvailableForPurchaseAfterRent ? t("calendar-select-trial-period") : t("select-your-dates")}
            </Modal.Title>
            <p>{props.details?.isAvailableForPurchaseAfterRent ? t("calendar-trial-description") : t("select-your-dates-validation")}</p>
          </Modal.Header>
          <Modal.Body>
            {/*  */}
            <div className="calendar-tab">
              <Tab.Container
                id="custom-calendar-tab"
                defaultActiveKey={
                  getDefaultActiveKey()
                }
              >
                <Nav
                  onSelect={(selectedKey: any) => setActiveTab(selectedKey)}
                  className={`${props.details?.edit || (props?.details?.monthlyChecked || props?.details?.monthlyRecurringChecked) ? 'monthly-tab' : ' '}`}>
                  <Nav.Item>
                    <Nav.Link
                      disabled={isDayOrLessDisabled}
                      eventKey="hourly"
                      onClick={() => {
                        if (!props.details?.edit) {
                          setCalendarValue(new Date());
                          setStartTime(null);
                          setEndTime(null);
                          setReturnEndDate('');
                          setDateRange([null, null]);
                          setSelectedDay(null);
                          setSelectedMonth(null);
                          setActiveTab('hourly');
                          setIsButtonDisabled(true);
                          setDateRange([null, null]);
                          handleDateChange([new Date(), new Date()], "one")
                        }
                      }}
                    >
                      <Clock /> {t("hourly")}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      disabled={isMultipleDaysDisabled}
                      eventKey="daily"
                      onClick={() => {
                        setRentPrice(null);
                        setDateRange([null, null]);
                        setSelectedDay(null);
                        setSelectedMonth(null);
                        setStartTime(null);
                        setEndTime(null);
                        setActiveTab('daily');
                        setReturnEndDate('');
                        setIsButtonDisabled(true);
                        changeSelectedDay(new Date());
                      }}
                    >
                      <CalendarSimpleIcon /> {t("daily")}
                    </Nav.Link>
                  </Nav.Item>
                  {(props?.details?.monthlyChecked || props?.details?.productDetailsByUUID?.monthlyChecked
                    || props?.details?.monthlyRecurringChecked || props?.details?.productDetailsByUUID?.monthlyRecurringChecked
                  ) &&
                    <Nav.Item>
                      <Nav.Link
                        disabled={isMonthlyDisabled}
                        eventKey="monthly"
                        onClick={() => {
                          if (!props.details?.edit) {
                            setReturnEndDate('');
                            setDateRange([null, null]);
                            setActiveTab('monthly');
                            setStartTime(null);
                            setEndTime(null);
                            setSelectedDay(null);
                            setSelectedMonth(null);
                            setIsButtonDisabled(true);
                            // Auto-select today's date
                            const today = new Date();
                            handleDateChange([today, today], "monthly");
                            setCalendarValue(today);
                            setDateRange([today, today]);
                          }
                        }}
                      >
                        <CalendarMontlyIcon /> {t("monthly")}
                      </Nav.Link>
                    </Nav.Item>
                  }
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="hourly">
                    <div className="row">
                      <div className="col-xxl-6 col-xl-6 col-lg-6 devider-model">
                        <div className="custom-calendar">
                          <Calendar
                            onChange={(value: any) => {
                              handleDateChange([value, value], "one", true);
                              setCalendarValue(value);
                              setStartTime(null);
                              fetchHourlyBlockedSlots(value);
                            }}
                            value={calendarValue}
                            minDate={new Date()}
                            maxDate={maxDate}
                            tileClassName={tileClassName}
                            tileDisabled={({ date }) => isDateDisabled(date)}
                          />
                        </div>
                      </div>
                      <div className="col-xxl-6 col-xl-6 col-lg-6">
                        <div className="calendar-content">
                          <div className="data-details time-details">
                            <div className="calendar-date-data">
                              <div className="time-select">
                                <div
                                  className={`floating-label-container ${isFocused ? "focused" : ""
                                    }`}
                                >
                                  <label className="floating-label">
                                    {t("start-time")}
                                  </label>
                                  <Select
                                    options={availableStartTimeOptions}
                                    styles={customStyles(isFocused)}
                                    onChange={(selectedOption) => {
                                      setStartTime(selectedOption);
                                      setFullDayValue("");

                                      // Clear end time when start time changes
                                      setEndTime(null);

                                      // If we have a selected date and a new start time, update end time options
                                      if (selectedOption && calendarValue) {
                                        // Call handleChangeStartTime after state update
                                        setTimeout(() => handleChangeStartTime(), 0);
                                      }
                                    }}
                                    value={startTime}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    menuPlacement="top"
                                    onMenuOpen={handleMenuOpen}
                                    onMenuClose={handleMenuClose}
                                    isDisabled={!calendarValue || noTimeSlotsAvailable}
                                    isClearable={false}
                                    isSearchable={false}
                                    classNamePrefix="react-select"
                                    className="time-select-dropdown"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="calendar-date-data">
                              <div className="time-select">
                                <div
                                  className={`floating-label-container ${isFocused ? "focused" : ""
                                    }`}
                                >
                                  <label className="floating-label">
                                    {"end-time"}
                                  </label>
                                  <Select
                                    options={(() => {
                                      let opts = endTimeOptions;
                                      if (activeTab === 'hourly' && startTime && blockedHourlySlots.length > 0) {
                                        const start24 = optionTimeTo24h(startTime.value);
                                        const [sh, sm] = start24.split(':').map(Number);
                                        const startMins = sh * 60 + sm;
                                        opts = opts.filter(opt => {
                                          if (!opt.value || opt.value === 'Full Day') return true;
                                          const endMins = parseInt(opt.value);
                                          return !blockedHourlySlots.some(slot => {
                                            const [bh, bm] = slot.split(':').map(Number);
                                            const slotMins = bh * 60 + bm;
                                            return slotMins > startMins && slotMins <= endMins;
                                          });
                                        });
                                      }
                                      return opts.length > 0 ? opts : [{ value: "", label: "No options available", isDisabled: true }];
                                    })()}
                                    styles={customStyles(isFocused)}
                                    onChange={(selectedOption) => {
                                      setEndTime(selectedOption);

                                      // When end time is selected, update the button state
                                      if (selectedOption) {
                                        setIsButtonDisabled(false);
                                      } else {
                                        setIsButtonDisabled(true);
                                      }
                                    }}
                                    value={endTime}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    menuPlacement="top"
                                    onMenuOpen={handleMenuOpen}
                                    onMenuClose={handleMenuClose}
                                    isDisabled={!startTime || noTimeSlotsAvailable}
                                    isClearable={false}
                                    isSearchable={false}
                                    classNamePrefix="react-select"
                                    className="time-select-dropdown"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="rent-cost-box">
                            <h6 className="rent-cost-title">
                              {props.details?.isAvailableForPurchaseAfterRent ? t("trial-cost") : t("rental-costs")}
                            </h6>
                            <div className="rent-cost">
                              <div className="rent-details days">
                                <h5>
                                  {fullDayValue === `${t("full-day")}`
                                    ? `1 ${t("day")}`
                                    : endTime?.key === 'threeAndHalfHours'
                                      ? '3.5 Hours'
                                      : endTime?.key === 'sevenAndHalfHours'
                                        ? '7.5 Hours'
                                        : endTime?.label
                                          ? endTime?.label.match(/\((\d+(?:\.\d+)?)\s*hr[s]?\)/)?.[1] + (endTime?.label.includes('hrs') ? ' Hours' : ' Hour')
                                          : endTime
                                            ? `1 ${t("day")}`
                                            : `${t("hours")}`}
                                </h5>
                              </div>
                              <div className="rent-details">
                                <h5 className="">
                                  £{rentPrice ? rentPrice : 0}
                                </h5>
                              </div>
                            </div>
                          </div>

                          {props.details?.isAvailableForPurchaseAfterRent && (
                            <div className="ownit-box d-flex align-items-center justify-content-between">
                              <div>
                                <div className="ownit-text-black">OWN<span>it</span></div>
                                <label
                                  htmlFor="optional-price-after-trial"
                                  className="form-check-label"
                                >
                                  {t("optional-price-after-trial")}
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id={`tooltip-op`}>
                                        <div dangerouslySetInnerHTML={{ __html: t("optional-price-after-trial-tooltip") }} />
                                      </Tooltip>
                                    }
                                  >
                                    <Info className="info-icon ms-2" size={18} />
                                  </OverlayTrigger>
                                </label>
                              </div>
                              <div className="ownit-price-text text-end">
                                {(() => {
                                  const purchasePrice = quateCharges?.ownItPricing?.purchasePrice;
                                  return (
                                    <div className="ownit-price">
                                      {purchasePrice ? `£${purchasePrice.toFixed(2)}` : ''}
                                    </div>
                                  );
                                })()}
                                {quateCharges?.ownItPricing?.discountPercentage && (
                                  <div><span className="fw-bold">{quateCharges?.ownItPricing?.discountPercentage || 'X'}% off</span> retail price</div>
                                )}
                                {!quateCharges?.ownItPricing?.discountPercentage && (
                                  <div>Set your trial duration</div>
                                )}
                              </div>
                            </div>
                          )}

                          {noTimeSlotsAvailable && (
                            <div className="no-time-slots-message">
                              <Info size={15} />
                              <span>
                                {isSelectedDateToday
                                  ? "No time slots are currently available for today. Please select a different date."
                                  : "No time slots are available for the selected date. Please select a different date."}
                              </span>
                            </div>
                          )}

                          <div className="continue-btn">
                            <Button
                              btnText={t("continue")}
                              disabled={
                                isButtonDisabled ||
                                !isProductAvailable ||
                                !isProductEnabled ||
                                isLoading
                              }
                              onClick={submit}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="daily">
                    <div className="row">
                      <div className="col-xxl-6 col-xl-6 col-lg-6 devider-model">
                        <div className="custom-calendar custom-calendar-daily">
                          <Calendar
                            onChange={(value: any) => {
                              changeSelectedDay(value)
                            }}
                            value={dateRange ?
                              selectedDay && selectedDay?.value !== dayOptionValue.ONE_DAY
                                ? dateRange : dateRange[0]
                              : [new Date(), new Date()]}
                            minDate={new Date()}
                            maxDate={maxDate}
                            tileClassName={tileClassName}
                            tileDisabled={({ date }) => isDateDisabled(date)}
                          />
                        </div>
                      </div>
                      <div className="col-xxl-6 col-xl-6 col-lg-6">
                        <div className="calendar-content">
                          {(() => {
                            const selectedDate = dateRange[0] || new Date();
                            const dayOfWeek = selectedDate.toLocaleDateString("en-US", { weekday: "long" });
                            const scheduleForDay = storeSchedule.find((s: Schedule) => s.dayOfWeek === dayOfWeek);
                            const calIso = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`;
                            const activeOverride = timingOverrides?.find(o => {
                              const start = o.startDate.split("T")[0];
                              const end = o.endDate.split("T")[0];
                              return calIso >= start && calIso <= end;
                            });
                            if (activeOverride?.status === 'CLOSED') {
                              return (
                                <div className="store-hours-info store-hours-closed">
                                  <Clock size={14} />
                                  <span>Store closed on this day</span>
                                </div>
                              );
                            }
                            // let openTime = scheduleForDay?.openTime;
                            // let closeTime = scheduleForDay?.closeTime;
                            // let isActive = scheduleForDay?.isActive;
                            // if (activeOverride?.status === 'OPEN' || activeOverride?.status === 'MODIFIED_HOURS') {
                            //   if (activeOverride.openTime) openTime = activeOverride.openTime;
                            //   if (activeOverride.closeTime) closeTime = activeOverride.closeTime;
                            //   isActive = true;
                            // }
                            // if (!isActive || !openTime || !closeTime) return null;
                            // const fmtTime = (t: string) => {
                            //   const [h, m] = t.split(":").map(Number);
                            //   const period = h < 12 ? "AM" : "PM";
                            //   const hr = h % 12 === 0 ? 12 : h % 12;
                            //   return `${hr}:${String(m).padStart(2, '0')} ${period}`;
                            // };
                            // return (
                            //   <div className="store-hours-info">
                            //     <Clock size={14} />
                            //     <span>Store hours: {fmtTime(openTime)} - {fmtTime(closeTime)}</span>
                            //   </div>
                            // );
                          })()}
                          <div className="data-details">
                            <div className="calendar-date-data">
                              <h5>{t("start-day")}</h5>
                              {dateRange[0] ? (
                                <FormattedDateComponent date={dateRange[0]} />
                              ) : (
                                <h6>Start day</h6>
                              )}
                            </div>
                            <div className="time-details daily-time-details">
                              <div className="time-select">
                                <div
                                  className={`floating-label-container ${isFocused ? "focused" : ""
                                    }`}
                                >
                                  <label className="floating-label">
                                    {t("select-term")}
                                  </label>
                                  <Select
                                    options={dayOptions}
                                    styles={customStyles(isFocused)}
                                    onChange={(selectedOption) =>
                                      setSelectedDay(selectedOption)
                                    }
                                    components={{ Option: CustomOption }}
                                    value={selectedDay}
                                    onFocus={handleFocus}
                                    noOptionsMessage={() => 'Select a start date'} // This hides the "No options" message
                                    menuPlacement="top"
                                    onMenuOpen={handleMenuOpen}
                                    onMenuClose={handleMenuClose}
                                    isClearable={false}
                                    isSearchable={false}
                                    isDisabled={!dateRange[0]}
                                  />
                                </div>
                              </div>

                            </div>
                          </div>

                          <div className="rent-cost-box">
                            <h6 className="rent-cost-title">
                              {props.details?.isAvailableForPurchaseAfterRent ? t("trial-cost") : t("rental-costs")}
                            </h6>
                            <div className="rent-cost">
                              <div className="rent-details days">
                                <h5>
                                  {countDays(dateRange[0], dateRange[1])}{" "}
                                  {t("days")}
                                </h5>
                              </div>
                              <div className="rent-details">
                                <h5 className="">
                                  £{rentPrice ? rentPrice : 0}
                                </h5>
                              </div>
                            </div>
                          </div>

                          {props.details?.isAvailableForPurchaseAfterRent && (
                            <div className="ownit-box d-flex align-items-center justify-content-between">
                              <div>
                                <div className="ownit-text-black">OWN<span>it</span></div>
                                <label
                                  htmlFor="optional-price-after-trial"
                                  className="form-check-label"
                                >
                                  {t("optional-price-after-trial")}
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id={`tooltip-op`}>
                                        <div dangerouslySetInnerHTML={{ __html: t("optional-price-after-trial-tooltip") }} />
                                      </Tooltip>
                                    }
                                  >
                                    <Info className="info-icon ms-2" size={18} />
                                  </OverlayTrigger>
                                </label>
                              </div>
                              <div className="ownit-price-text text-end">
                                {(() => {
                                  const purchasePrice = quateCharges?.ownItPricing?.purchasePrice;
                                  return (
                                    <div className="ownit-price">
                                      {purchasePrice ? `£${purchasePrice.toFixed(2)}` : ''}
                                    </div>
                                  );
                                })()}
                                {quateCharges?.ownItPricing?.discountPercentage && (
                                  <div><span className="fw-bold">{quateCharges?.ownItPricing?.discountPercentage || 'X'}% off</span> retail price</div>
                                )}
                                {!quateCharges?.ownItPricing?.discountPercentage && (
                                  <div>Set your trial duration</div>
                                )}
                              </div>
                            </div>
                          )}

                          <div className="continue-btn">
                            <Button
                              btnText={t("continue")}
                              disabled={
                                isButtonDisabled ||
                                !isProductAvailable ||
                                !isProductEnabled ||
                                isLoading
                              }
                              onClick={submit}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="monthly">
                    <div className="row">
                      <div className="col-xxl-6 col-xl-6 col-lg-6 devider-model">
                        <div className="custom-calendar ">
                          <Calendar
                            onChange={(value: any) => {
                              handleDateChange([value, value], "monthly", true);
                              setCalendarValue(value);
                            }}
                            value={calendarValue}
                            minDate={new Date()}
                            maxDate={maxDate}
                            tileClassName={tileClassName}
                            tileDisabled={({ date }) => isDateDisabled(date)}
                          />
                        </div>
                      </div>
                      <div className="col-xxl-6 col-xl-6 col-lg-6">
                        <div className="calendar-content">
                          <div className="data-details ">
                            <div className="calendar-date-data">
                              {isFocused}
                              <h5>{t("start-day")}</h5>
                              {dateRange[0] ? (
                                <FormattedDateComponent date={dateRange[0]} />
                              ) : (
                                <h6>Start day</h6>
                              )}
                            </div>
                            <div className="time-details monthly-time-details">
                              <div className="time-select">
                                <div
                                  className={`floating-label-container ${isFocused ? "focused" : ""
                                    }`}
                                >
                                  <label className="floating-label">
                                    {"Select term"}
                                  </label>
                                  <Select
                                    options={monthOptions}
                                    styles={customStyles(isFocused)}
                                    onChange={(selectedOption) =>
                                      setSelectedMonth(selectedOption)
                                    }
                                    components={{ Option: CustomOption }}
                                    value={selectedMonth}
                                    onFocus={handleFocus}
                                    menuPlacement="top"
                                    onMenuOpen={handleMenuOpen}
                                    onMenuClose={handleMenuClose}
                                    isClearable={false}
                                    isSearchable={false}
                                  />
                                </div>
                              </div>

                            </div>
                          </div>

                          <div className="rent-cost-box">
                            <h6 className="rent-cost-title">
                              {props.details?.isAvailableForPurchaseAfterRent ? t("trial-cost") : t("rental-costs")}
                            </h6>
                            <div className="rent-relative">  <div className="rent-cost">
                              <div className="rent-details days">
                                <h5>
                                  £{productRentalValue ? productRentalValue : 0}
                                </h5>
                              </div>
                              <div className="rent-details">
                                <h5 className="">
                                  Per month
                                </h5>
                              </div>
                            </div>
                            </div>
                          </div>

                          {props.details?.isAvailableForPurchaseAfterRent && (
                            <div className="ownit-box d-flex align-items-center justify-content-between">
                              <div>
                                <div className="ownit-text-black">OWN<span>it</span></div>
                                <label
                                  htmlFor="optional-price-after-trial"
                                  className="form-check-label"
                                >
                                  {t("optional-price-after-trial")}
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id={`tooltip-op`}>
                                        <div dangerouslySetInnerHTML={{ __html: t("optional-price-after-trial-tooltip") }} />
                                      </Tooltip>
                                    }
                                  >
                                    <Info className="info-icon ms-2" size={18} />
                                  </OverlayTrigger>
                                </label>
                              </div>
                              <div className="ownit-price-text text-end">
                                {(() => {
                                  const purchasePrice = quateCharges?.ownItPricing?.purchasePrice;
                                  return (
                                    <div className="ownit-price">
                                      {purchasePrice ? `£${purchasePrice.toFixed(2)}` : ''}
                                    </div>
                                  );
                                })()}
                                {quateCharges?.ownItPricing?.discountPercentage && (
                                  <div><span className="fw-bold">{quateCharges?.ownItPricing?.discountPercentage || 'X'}% off</span> retail price</div>
                                )}
                                {!quateCharges?.ownItPricing?.discountPercentage && (
                                  <div>Set your trial duration</div>
                                )}
                              </div>
                            </div>
                          )}
                          {selectedMonth && selectedMonth?.label === monthOptionLabel.FULLly_FLEXIBLE && (
                            <small className="mb-2 d-block text-center fw-medium">
                              Rental agreements will roll into a month-by-month
                              agreement until the item is returned or
                              for a maximum of 12 consecutive
                              monthly terms.
                            </small>
                          )}

                          <div className="continue-btn">
                            <Button
                              btnText={t("continue")}
                              disabled={
                                isButtonDisabled ||
                                !isProductAvailable ||
                                !isProductEnabled ||
                                isLoading
                              }
                              onClick={submit}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </Modal.Body>
          {/* <Modal.Footer>
            <Button btnText='Continue' disabled={!dateRange} onClick={submit} />
          </Modal.Footer> */}
        </div>
      </Modal>
      {/* Modal for displaying alerts */}
      <CustomModal
        show={showAlert}
        message={t("date-overlaps-validation-message")}
        onHide={() => handleAlertDismiss()}
      />
    </div>
  );
};

export default CalendarModal;